import { React, useState, useEffect, useContext, useRef, useCallback } from 'react'
import { Button } from 'bootstrap'
import "../css/PagesCommonStyle.css"
import { faMagnifyingGlass, faPrint, faCircleCheck, faCircleUser, faShieldHalved, faCreditCard, faListCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faXmark, faArrowRight, faSpinner, faPlus, faMinus } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, ClaimApprovalConstants, ClaimStatusConstants, CommonAPIConstants, PostingpaymentsConstants, FilesAPIConstants, TransactionLogsConstants } from '../utilities/Constants'
import * as XLSX from 'xlsx';
import { setUser } from '../redux/actions/userActions'
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import Draggable from 'react-draggable'
import { useParams, useLocation } from 'react-router-dom';


const TransactionLogs = () => {

    const getCurrentDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // Default value for the input is the current date
    const defaultDate = getCurrentDate();
    const defaultFromDate = new Date('2015-01-01');

    const today = new Date();
    const formatCurDate = format(today, 'MM/dd/yyyy');

    const rowsPerPage = 100;

    const [isHideChecked, setIsHideChecked] = useState(false);
    const [updatedTabledata, setUpdatedTableData] = useState([]);
    const [error, setError] = useState(null);
    const [startDate, setStartDate] = useState(defaultDate, defaultFromDate); // State to store start date
    const [endDate, setEndDate] = useState(defaultDate);     // State to store end date
    const [loading, setLoading] = useState(false);


    const ServiceLocValues = [
        { TextField: 'Office - 11', ValueField: '11' },
        { TextField: 'Home - 12', ValueField: '12' },
        { TextField: 'SUD - 57', ValueField: '57' },
        { TextField: 'Lab - 81', ValueField: '81' },


    ];

    const [ServiceLocations, setServiceLocations] = useState([]);
    const [selectedCMS33a, setSelectedCMS33a] = useState('0');
    const [selectedCMS33b, setSelectedCMS33b] = useState('0');
    const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
    const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
    const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
    const [selectedSearchFilter, setSelectedSearchFilter] = useState('9');
    const [selectedLocation, setSelectedLocation] = useState('-1');
    const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('');
    const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
    const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
    const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');


    const [locations, setLocations] = useState([]);
    const [cms33aData, setCMS33aData] = useState([]);
    const [cms33bData, setCMS33bData] = useState([]);
    const [providerCategory, setProviderCategory] = useState([]);
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [practiceProvider, setPracticeProvider] = useState([]);
    const [statusRadioButton, setStatusRadioButton] = useState([]);
    const [checkedRadioButton, setCheckedRadioButton] = useState([]);

    const [BillingNPIs, setBillingNPIs] = useState([]);

    const [searchText, setSearchText] = useState('');

    const [suggestions, setSuggestions] = useState([]);
    const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
    const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
    const [sPatID, setSPatID] = useState('');
    const [sInsID, setSInsID] = useState('');
    const [sClaimStatus, setsClaimStatus] = useState('');
    const [rowsValidation, setRowsValidation] = useState('');
    const [isChecked, setIsChecked] = useState(false);



    const [tableDetails, setTableDetails] = useState([]);
    const [tableInsDetails, setTableInsDetails] = useState([]);
    const [checkEligibility, setCheckEligibility] = useState([]);
    const [selectedClaims, setSelectedClaims] = useState([]);
    const [selectAllDropdown, setSelectAllDropdown] = useState([]);
    const [checkboxes, setCheckboxes] = useState();


    const [selectedRows, setSelectedRows] = useState([]);

    const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
    const [SecInsuranceAllCheckbox, setSecInsuranceAllCheckbox] = useState([]);
    const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);


    const [searchByPatient, setSearchByPatient] = useState('');
    const [searchByDOB, setSearchByDOB] = useState('');
    const [searchByInsurance, setSearchByInsurance] = useState('');
    const [searchByProvider, setSearchByProvider] = useState('');
    const [searchByCPT, setSearchByCPT] = useState('');
    const [searchByDOS, setSearchByDOS] = useState('');
    const [searchByPostingDate, setSearchByPostingDate] = useState('');
    const [searchBySubmitdate, setSearchBySubmitdate] = useState('');
    const [searchBySecSubmitdate, setSearchBySecSubmitdate] = useState('');
    const [searchByICD, setSearchByICD] = useState('');
    const [searchByTotalCharge, setSearchByTotalCharge] = useState('');
    const [searchByStatus, setSearchByStatus] = useState('');
    const [searchByRecievedCharge, setSearchByRecievedCharge] = useState('');
    const [searchBySubmitter, setSearchBySubmitter] = useState('');
    const [searchByClaim, setSearchByClaim] = useState('');
    const [searchByRcvdCharge, setSearchByRcvdCharge] = useState('');
    const [searchByWriteOffValue, setSearchByWriteOffValue] = useState('');
    const [searchByAdminWriteOffValue, setSearchByAdminWriteOffValue] = useState('');
    const [searchByBalance, setSearchByBalance] = useState('');
    const [searchByCheckNum, setSearchByCheckNum] = useState('');
    const [searchByCheckDate, setSearchByCheckDate] = useState('');
    const [searchByPayerRef, setSearchByPayerRef] = useState('');
    const [searchByDeductible, setSearchByDeductible] = useState('');
    const [searchByPatientRes, setSearchByPatientRes] = useState('');
    const [searchByClearingHouse, setSearchByClearingHouse] = useState('');
    const [searchByUpdatedBy, setSearchByUpdatedBy] = useState('');
    const [searchBySubmittedBy, setSearchBySubmittedBy] = useState('');
    const [searchByCopay, setSearchByCopay] = useState('');

    const [searchBySecRcvdCharge, setSearchBySecRcvdCharge] = useState('');
    const [searchBySecInsurance, setSearchBySecInsurance] = useState('');
    const [searchBySecCheckNum, setSearchBySecCheckNum] = useState('');
    const [searchBySecCheckDate, setSearchBySecCheckDate] = useState('');
    const [searchBySecPayerRef, setSearchBySecPayerRef] = useState('');
    const [searchByAdjustmentAmt, setSearchByAdjustmentAmt] = useState('');
    const [searchBySecPendingAmt, setSearchBySecPendingAmt] = useState('');

    const [selectedTextField, setSelectedTextField] = useState('');
    const [selectedValueField, setSelectedValueField] = useState('');
    const [selectedRecValue, setSelectedRecValue] = useState('all'); // Default value is 25
    const [totalRecords, setTotalRecords] = useState(0);
    const [displayedRecords, setDisplayedRecords] = useState([]);
    const [selectedDropdownValue, setSelectedDropdownValue] = useState('DOS');

    const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
    const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
    const [showVerifiedSaveModal, setShowVerifiedSaveModal] = useState(false);
    const [showServiceErrorModal, setShowServiceErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
    const [closeClaimsModal, setCloseClaimsModal] = useState(false);
    const [savedRowCount, setSavedRowCount] = useState(0);
    const [deleteRowCount, setDeleteRowCount] = useState(0);
    const [successTimer, setSuccessTimer] = useState(5000);

    const [appointmentDates, setAppointmentDates] = useState([]);
    const [selectLocationID, setSelectLocationID] = useState('-1');
    const [showFilters, setShowFilters] = useState(false);
    const [showDetails, setShowDetails] = useState(false);

    const [claimservices, setClaimServices] = useState([]);
    const [selectedCptValue, setSelectedCptValue] = useState('');
    const [cptValueList, setCptValueList] = useState([]);
    const [selectedCPTCode, setSelectedCPTCode] = useState('');
    const [insOrPatFilter, setInsOrPatFilter] = useState('updatedby');
    const [practiceBillingNPIs, setPracticeBillingNPIs] = useState([]);
    const [selectpracticeBillingNPIs, setSelectPracticeBillingNPIs] = useState('');
    const [selectedViewType, setSelectedViewType] = useState('0');
    const [selectedClaimService, setSelectedClaimService] = useState('0');
    const [isClaimClosed, setIsClaimClosed] = useState('false');

    const [claimFilterRecCountsTableData, setClaimFilterRecCountsTableData] = useState([]);
    const [claimRecCountsTableData, setClaimRecCountsTableData] = useState(claimFilterRecCountsTableData);
    const [defaultUpdatedBy, setDefaultUpdatedBy] = useState('Test Biller');

    const [checkedServices, setCheckedServices] = useState([]);
    const [isNoServiceChecked, setIsNoServiceChecked] = useState(false);

    const [selectedPolicyRows, setSelectedPolicyRows] = useState([]);
    const [selectedInsRows, setSelectedInsRows] = useState([]);
    const [selectedSecInsuranceRows, setSelectedSecInsuranceRows] = useState([]);
    const [selectedAdminWriteRows, setSelectedAdminWriteRows] = useState([]);
    const [selectedWriteOffRows, setSelectedWriteOffRows] = useState([]);
    const [selectedResubmitRows, setSelectedResubmitRows] = useState([]);
    const [transactionCodes, setTransactionCodes] = useState([]);
    const [selectedTransactionCode, setSelectedTransactionCode] = useState('');
    const [verifiedData, setVerifiedData] = useState([]);
    const [selectedVerifiedData, setSelectedVerifiedData] = useState([]);
    const [billingNpiValue, setBillingNpiValue] = useState('');
    const [claimId, setClaimId] = useState('');
    const [cptCode, setCptCode] = useState('');
    const [dos, setDos] = useState('');
    const [savingData, setSavingData] = useState(false);
    const [dataSaved, setDataSaved] = useState(false);

    const [isClaimChecked, setIsClaimChecked] = useState(true);
    const [isSubmitChecked, setIsSubmitChecked] = useState(true);
    const [isNonSubmitChecked, setIsNonSubmitChecked] = useState(true);
    const [isSentChecked, setIsSentChecked] = useState(true);
    const [isPaidChecked, setIsPaidChecked] = useState(true);
    const [isRecvdChecked, setIsRecvdChecked] = useState(true);
    const [isDeniedChecked, setIsDeniedChecked] = useState(true);
    const [isRejectedChecked, setIsRejectedChecked] = useState(true);
    const [isForwardChecked, setIsForwardChecked] = useState(true);
    const [isPostedChecked, setIsPostedChecked] = useState(true);


    const [claimNotes, setClaimNotes] = useState([]);


    const [isLoading, setIsLoading] = useState('');
    const [isInStatus, setIsInStatus] = useState(false);

    const [payRefColor, setPayRefColor] = useState(false);
    const [activeRow, setActiveRow] = useState(null);
    const [selectedServiceIDs, setSelectedServiceIDs] = useState([]);
    const [prevFilter, setPrevFilter] = useState('');
    const [queryFilter, setQueryFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState(null);
    const [selectedAllChecked, setSelectedAllChecked] = useState(false);
    const [selectAllWriteOffChecked, setSelectAllWriteOffChecked] = useState(false);
    const [selectAllAdminWriteChecked, setSelectAllAdminWriteChecked] = useState(false);
    const [selectAllResubmit, setSelectAllResubmit] = useState(false);
    const [selectedData, setSelectedData] = useState('');
    const [isPageLoad, setisPageLoad] = useState('1');
    const [searchByClaimDos, setSearchByClaimDos] = useState('');

    const [showDataModal, setShowDataModal] = useState(false);
    const [eventData, setEventData] = useState([]);
    const [selectedClaimID, setselectedClaimID] = useState([]);
    const [showFaxModal, setShowFaxModal] = useState(false);

    const [reGenerateData, setReGenerateData] = useState(false);
    const [rowState, setRowState] = useState({});
    const [isHidden, setIsHidden] = useState(false);
    const [selectedPatname, setselectedPatname] = useState('');
    const [selectedDOB, setselectedDOB] = useState('');
    const [isStartOpen, setIsStartOpen] = useState(false);
    const [isEndOpen, setIsEndOpen] = useState(false);
    const [searchByLocation, setSearchByLocation] = useState('');
    const [claimID, setClaimID] = useState('');
    const [activeCounts, setActiveCounts] = useState(null);
    const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
    const [errorMessage, setErrorMessage] = useState("");
    const [showCopaySuccessModal, setShowCopaySuccessModal] = useState(false);
    const [selectedMacro, setselectedMacro] = useState('0');

    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [categoryFilteredClaims, setCategoryFilteredClaims] = useState([]);
    const [allClaims, setAllClaims] = useState([]);
    const tableContainerRef = useRef(null);
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");

    const [expandedRows, setExpandedRows] = useState({});
    const [auditData, setAuditData] = useState({});
    const [transactionData, setTransactionData] = useState([]);
    const [highlightCPTs, setHighlightCPTs] = useState([]);
    const [activeView, setActiveView] = useState('claimInfo');
    const { id } = useParams();
    const location = useLocation();




    const extractCPTValue = (item) => {
        const cptKeys = ['CPTOld', 'EncCPT', 'CPT', 'sCPTcode', 'ProviderCPT'];

        for (const key of cptKeys) {
            if (item[key]) return item[key].toString().trim();
        }

        return '';
    };





    useEffect(() => {
        const saved = localStorage.getItem('selectedClaimItem');

        if (saved) {
            const item = JSON.parse(saved);
            const rawCPT = item.CPTOld || item.EncCPT || item.CPT || item.sCPTcode || item.ProviderCPT || '';

            let cptArray = [];

            if (typeof rawCPT === 'string') {
                cptArray = rawCPT.split(',').map(cpt => cpt.trim());
            } else if (Array.isArray(rawCPT)) {
                cptArray = rawCPT.map(cpt => cpt.toString().trim());
            } else {
                cptArray = [];
            }

            console.log('Parsed CPTs:', cptArray);
            setHighlightCPTs(cptArray);

            localStorage.removeItem('selectedClaimItem');
        }
    }, []);





    const sAuthToken = useSelector((state) => state.user.token);



    const loadMoreRecords = useCallback(() => {
        setVisibleRecords((prev) => {
            const next = Math.min(prev + rowsPerPage, displayedRecords.length);


            if (next > prev) {
                setPopupMessage(`${next} records out of ${displayedRecords.length} loaded`);
                setShowPopup(true);


                setTimeout(() => {
                    setShowPopup(false);
                }, 3000);
            }

            return next;
        });
    }, [displayedRecords.length]);


    const handleScroll = useCallback(() => {
        const isAtBottom =
            window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;

        if (isAtBottom) {
            loadMoreRecords();
        }
    }, [loadMoreRecords]);




    useEffect(() => {
        setVisibleRecords(rowsPerPage);
    }, [displayedRecords]);




    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [handleScroll]);




    const [totals, setTotals] = useState({
        allClaims: 0,
        totalUnits: 0,
        totalSubmitted: 0,
        totalReceived: 0,
        totalSecReceived: 0,
        totalAdjustmentAmt: 0,
        totalSecPendingAmt: 0,
        totalDeductible: 0,
        totalPatientRes: 0,
        totalWriteOff: 0,
        totalAdminWriteOff: 0,
        totalBalance: 0,
        totalCopay: 0

    });


    const [totalsClaims, setTotalsClaims] = useState({
        allClaims: 0,
        totalSubmitClaim: 0,
        totalNonSubmitted: 0,
        totalSent: 0,
        totalForwarded: 0,
        totalReceivedClaim: 0,
        totalSecReceivedClaim: 0,
        totalDeductibleClaim: 0,
        totalPosted: 0,
        totalPaid: 0,
        totalRejected: 0,
        totalDenied: 0,

    });




    const dispatch = useDispatch();




    const userData = useSelector((state) => state.user.user);


    localStorage.setItem('userData2', JSON.stringify(userData));


    var userPracticeID = userData ? userData.practiceID : null;

    var userId = userData ? userData.userID : null;



    useEffect(() => {
        document.title = 'ClaimTransactionandLogs'


        const initialCheckedServices = claimservices.map((item) => item.ServiceID);
        setCheckedServices(initialCheckedServices);
        setShowServiceErrorModal(false)
    }, [claimservices]);


    useEffect(() => {
        const selectedIds = checkedServices.filter((id) => id !== 0);
        setSelectedServiceIDs(selectedIds);
        setShowServiceErrorModal(false)
    }, [checkedServices]);





    const handleClaimServiceChange = (item) => {


        if (item.ServiceID === '0') {

            setCheckedServices(isNoServiceChecked ? [] : claimservices.map((service) => service.ServiceID));
        } else {

            const updatedServices = checkedServices.includes(item.ServiceID)
                ? checkedServices.filter((selectedId) => selectedId !== item.ServiceID)
                : [...checkedServices, item.ServiceID];
            setCheckedServices(updatedServices);

        }
        updateSelectedServiceIds();
    };




    const updateSelectedServiceIds = () => {
        const selectedIds = checkedServices.includes('0')
            ? checkedServices.filter((id) => id !== '0')
            : checkedServices;

        setSelectedServiceIDs(selectedIds);
    };









    useEffect(() => {
        let timerId;


        if (showSuccessModal || deleteSuccessModal) {
            // Start the timer when the success modal is shown
            timerId = setTimeout(() => {
                setShowSuccessModal(false);
                setDeleteSuccessModal(false);
                setShowServiceErrorModal(false);

            }, successTimer);
        }


        return () => {
            clearTimeout(timerId);
        };
    }, [showSuccessModal, successTimer, deleteSuccessModal]);


    const modalRef = useRef(null);





    useEffect(() => {

        const handleOutsideClick = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowConfirmSaveModal(false);
            }
        };

        // Add event listener
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);






    const handleTodayClick = (dateType) => {
        const today = new Date();

        if (dateType === "start" && startDate) {
            setStartDate(today);

            setIsStartOpen(false);
        }

        if (dateType === "end" && endDate) {
            setEndDate(today);
            setIsEndOpen(false);
        }
    };






    useEffect(() => {

        if (selectedRecValue === 'all') {
            setDisplayedRecords(filteredTableDetails);
        } else {
            setDisplayedRecords(filteredTableDetails.slice(0, selectedRecValue));
        }
    }, [filteredTableDetails, selectedRecValue]);




    useEffect(() => {
        if (displayedRecords && Array.isArray(displayedRecords)) {
            setTotalRecords(displayedRecords.length);
        } else {
            setTotalRecords(0);
        }
    }, [displayedRecords]);






    //Get all total Records of Main Table

    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === 'string') {
                const cleanedAmount = amount.replace(/\$/g, '').trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === 'number') {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotals({
            totalUnits: 0,
            totalSubmitted: 0,
            totalReceived: 0,
            totalWriteOff: 0,
            totalAdminWriteOff: 0,
            totalAdjustmentAmt: 0,
            totalSecPendingAmt: 0,
            totalBalance: 0,
            totalSecReceived: 0,
            totalDeductible: 0,
            totalPatientRes: 0,
            totalCopay: 0
        });

        // Loop through displayedRecords to calculate new totals
        displayedRecords.forEach((claim) => {
            const curRowunits = claim['Units']?.trim();
            const curRowCharges = claim['totalcharge'];
            const totalReceived = claim['recvdCharge'];
            const curRowWriteOff = claim['WriteOffAmount'];
            const curRowBalance = claim['claimbln'];
            const AdminWriteOff = claim['AdminWriteOff'];
            const totalDeductible = claim['Deductible'];
            const totalSecReceived = claim['SecrecvdCharge'];
            const totalPatientRes = claim['PatientAmount'];
            const AdjustmentAmt = claim['Adjustment'];
            const SecPendingAmt = claim['SecPendingAmt'];
            const CopayAmt = claim['Copay'];



            if (curRowunits !== undefined && curRowunits !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalUnits: prevTotals.totalUnits + parseInt(curRowunits) }));

            if (curRowCharges !== undefined && curRowCharges !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSubmitted: prevTotals.totalSubmitted + parseAmount(curRowCharges) }));

            if (totalReceived !== undefined && totalReceived !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalReceived: prevTotals.totalReceived + parseAmount(totalReceived) }));

            if (totalSecReceived !== undefined && totalSecReceived !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSecReceived: prevTotals.totalSecReceived + parseAmount(totalSecReceived) }));

            if (AdjustmentAmt !== undefined && AdjustmentAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalAdjustmentAmt: prevTotals.totalAdjustmentAmt + parseAmount(AdjustmentAmt) }));

            if (CopayAmt !== undefined && CopayAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalCopay: prevTotals.totalCopay + parseAmount(CopayAmt) }));

            if (SecPendingAmt !== undefined && SecPendingAmt !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalSecPendingAmt: prevTotals.totalSecPendingAmt + parseAmount(SecPendingAmt) }));

            if (totalDeductible !== undefined && totalDeductible !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalDeductible: prevTotals.totalDeductible + parseAmount(totalDeductible) }));

            if (totalPatientRes !== undefined && totalPatientRes !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalPatientRes: prevTotals.totalPatientRes + parseAmount(totalPatientRes) }));

            if (curRowWriteOff !== undefined && curRowWriteOff !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalWriteOff: prevTotals.totalWriteOff + parseAmount(curRowWriteOff) }));

            if (AdminWriteOff !== undefined && AdminWriteOff !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalAdminWriteOff: prevTotals.totalAdminWriteOff + parseAmount(AdminWriteOff) }));

            if (curRowBalance !== undefined && curRowBalance !== '')
                setTotals((prevTotals) => ({ ...prevTotals, totalBalance: prevTotals.totalBalance + parseAmount(curRowBalance) }));


        });
    }, [displayedRecords]);





    useEffect(() => {
        const parseAmount = (amount) => {
            if (typeof amount === 'string') {
                const cleanedAmount = amount.replace(/\$/g, '').trim();
                return cleanedAmount ? parseFloat(cleanedAmount) : 0;
            }
            if (typeof amount === 'number') {
                return amount;
            }
            return 0;
        };

        // Reset totals to zero before calculating new amounts
        setTotalsClaims({
            allClaims: 0,
            totalSubmitClaim: 0,
            totalNonSubmitted: 0,
            totalSent: 0,
            totalForwarded: 0,
            totalReceivedClaim: 0,
            totalPosted: 0,
            totalPaid: 0,
            totalRejected: 0,
            totalDenied: 0,
            totalCopay: 0
        });

        // Loop through claimRecCountsTableData to calculate new totals
        claimRecCountsTableData.forEach((claim) => {
            const allClaims = claim['AllClaims'];
            const totalSubmitClaim = claim['Submitted']?.trim();
            const totalNonSubmitted = claim['NonSubmitted'];
            const totalSent = claim['SENT'];
            const totalForwarded = claim['FORWARDED'];
            const totalReceivedClaim = claim['PaymentReceived'];
            const totalPosted = claim['PaymentPosted'];
            const totalPaid = claim['PAID'];
            const totalRejected = claim['REJECTED'];
            const totalDenied = claim['DENIED'];



            if (allClaims !== undefined && allClaims !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, allClaims: prevTotals.allClaims + parseInt(allClaims) }));

            if (totalSubmitClaim !== undefined && totalSubmitClaim !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalSubmitClaim: prevTotals.totalSubmitClaim + parseInt(totalSubmitClaim) }));

            if (totalNonSubmitted !== undefined && totalNonSubmitted !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalNonSubmitted: prevTotals.totalNonSubmitted + parseAmount(totalNonSubmitted) }));

            if (totalSent !== undefined && totalSent !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalSent: prevTotals.totalSent + parseAmount(totalSent) }));

            if (totalForwarded !== undefined && totalForwarded !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalForwarded: prevTotals.totalForwarded + parseAmount(totalForwarded) }));

            if (totalReceivedClaim !== undefined && totalReceivedClaim !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalReceivedClaim: prevTotals.totalReceivedClaim + parseAmount(totalReceivedClaim) }));

            if (totalPosted !== undefined && totalPosted !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalPosted: prevTotals.totalPosted + parseAmount(totalPosted) }));

            if (totalPaid !== undefined && totalPaid !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalPaid: prevTotals.totalPaid + parseAmount(totalPaid) }));

            if (totalRejected !== undefined && totalRejected !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalRejected: prevTotals.totalRejected + parseAmount(totalRejected) }));


            if (totalDenied !== undefined && totalDenied !== '')
                setTotalsClaims((prevTotals) => ({ ...prevTotals, totalDenied: prevTotals.totalDenied + parseAmount(totalDenied) }));


        });

        // ReloadClaimsData('all')
    }, [claimRecCountsTableData]);



    // Fetch all Transaction Codes

    useEffect(() => {


        var inputStruct = {


        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };


        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.GetTransactionCode, {
            method: 'POST',
            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })


            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);


                setTransactionCodes(parsedData)

            })

            .catch((error) => {
                console.error('Error fetching data: ', error);
            });

    }, [])




    //Filtered the data based on Checkboxes in MainTable


    useEffect(() => {
        let filteredClaimsList = [];

        if (isClaimChecked) {
            var allClaims = [...tableDetails];
            filteredClaimsList = filteredClaimsList.concat(allClaims);


        } else {
            if (isNonSubmitChecked) {
                const nonSubClaims = tableDetails.filter((claims) => claims.SubmitDate === '');
                filteredClaimsList = filteredClaimsList.concat(nonSubClaims);
            }

            if (isSubmitChecked) {
                const submittedClaims = tableDetails.filter((claims) => claims.SubmitDate !== '');
                filteredClaimsList = filteredClaimsList.concat(submittedClaims);
            }

            if (isSentChecked) {
                const sentClaims = tableDetails.filter((claims) => claims.ClaimStatusInt === 3);
                filteredClaimsList = filteredClaimsList.concat(sentClaims);
            }

            if (isForwardChecked) {
                const fwdClaims = tableDetails.filter((claims) => claims.ClaimStatusInt === 5);
                filteredClaimsList = filteredClaimsList.concat(fwdClaims);
            }


            if (isRecvdChecked) {
                const paymentRecvdClaims = tableDetails.filter((claims) => claims.isPaymentReceived);
                filteredClaimsList = filteredClaimsList.concat(paymentRecvdClaims);
            }

            if (isPaidChecked) {
                const paidClaims = tableDetails.filter((claims) => claims.ClaimStatusInt == 1);
                filteredClaimsList = filteredClaimsList.concat(paidClaims);
            }

            if (isRejectedChecked) {
                const rejectedClaims = displayedRecords.filter((claims) => claims.ClaimStatusInt == 2);
                filteredClaimsList = filteredClaimsList.concat(rejectedClaims);
            }

            if (isDeniedChecked) {
                const deniedClaims = displayedRecords.filter((claims) => claims.isDenied == 1);
                filteredClaimsList = filteredClaimsList.concat(deniedClaims);
            }



        }

        setDisplayedRecords(filteredClaimsList);
    }, [isClaimChecked, isNonSubmitChecked, isSubmitChecked, isSentChecked, isForwardChecked, isRecvdChecked, isPaidChecked,
        isRejectedChecked, isDeniedChecked]);











    useEffect(() => {
        // Set the default last 7 days' date range
        const today = new Date();
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);

        setStartDate(sevenDaysAgo);
        setEndDate(today);

        setSearchText(userData.userFullName)
        setSPatID(userData.userID)

        setisPageLoad(1)



    }, []);



    //Bind the approval table details



    const handleTableDataClick = (DataValidationMessage, selectedServiceIDs) => {


        setLoading(true);
        setActiveCounts(null)



        setSelectedAdminWriteRows([]);
        setSelectedPolicyRows([]);
        setSelectedWriteOffRows([]);
        setSelectedResubmitRows([]);

        setIsClaimChecked(true);
        setIsSubmitChecked(true);
        setIsNonSubmitChecked(true);
        setIsSentChecked(true);
        setIsForwardChecked(true);
        setIsRecvdChecked(true);
        setIsPostedChecked(true);
        setIsPaidChecked(true);
        setIsRejectedChecked(true);
        setIsDeniedChecked(true);

        if (checkedServices.length == 0) {


            setShowServiceErrorModal(true);


        } else {

            const sFilterType = selectedDropdownValue;
            var MissingData = DataValidationMessage;

            if (MissingData != "") {
                console.log("Datavalid", MissingData);
            }


            var strCPTGroups = [];

            var objInput = {

                iPracticeID: userPracticeID + "",
                sFromDate: startDate,
                sToDate: endDate,
                sFilterType: sFilterType,
                sPatientID: sPatID,
                sInsuranceID: sInsID,
                sCPT: selectedCptValue,
                sInsorPatFilter: "claimId",
                sLocationID: selectLocationID,
                sFilterText: id,
                ViewType: selectedViewType,
                isClosedClaims: isClaimClosed,
                sService: selectedServiceIDs,
                sCPTGroups: strCPTGroups,
                sClaimStatus: sClaimStatus,
                sDefaultSearch: true,
                roleID: userData.roleID,
                isMacro: selectedMacro,
                iProviderTemplateID: userData.iProviderTemplateID,
                DefaultTimeZoneOffSet: userData.DefaultTimeZoneOffSet

            }





            var myInput = JSON.stringify({ ObjClaims: objInput });

            console.log("Input of" + ClaimStatusConstants.GetClaimStatusData, myInput);

            const url = `${APIConstants.BASE_URL_BILLING}${ClaimStatusConstants.GetClaimStatusData}?sInputJSON=${myInput}`;



            fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sAuthToken}`
                }
            })

                .then((response) => {
                    if (response.status != 200) { console.log("response.status", response.status); }
                    else return response.json();
                })


                .then(data => {



                    const parsedTableData = JSON.parse(data);
                    const tableData = parsedTableData.Data[0];

                    setTableDetails(tableData);

                    console.log("Response of" + ClaimStatusConstants.GetClaimStatusData, tableData);
                    setTimeout(() => {
                        setLoading(false);
                        setFilteredTableDetails(tableData);

                    }, 10);





                    const claimCountsData = parsedTableData.Data[1];
                    setClaimFilterRecCountsTableData(claimCountsData)
                    setClaimRecCountsTableData(claimCountsData);
                    console.log("countClaim>>>>>>>>>>>>>>>", claimCountsData);


                    setShowServiceErrorModal(false);

                })

                .catch((error) => {
                    setError('API request failed');
                    setLoading(false);
                })


        }
    }






    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleTableDataClick();
        }
    };




    useEffect(() => {

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [selectedServiceIDs])









    const hasLoadedInitially = useRef(false);




    useEffect(() => {
        if (!hasLoadedInitially.current) {

            return;
        }


        if (hasLoadedInitially.current) {
            handleTableDataClick(searchText, selectedServiceIDs);
            hasLoadedInitially.current = false;
        }

        handleClaimServiceChange(selectedServiceIDs)

    }, [selectedServiceIDs]);




    useEffect(() => {
        if (isPageLoad && !hasLoadedInitially.current) {

            handleTableDataClick(searchText, selectedServiceIDs);

            hasLoadedInitially.current = true; // Mark the initial load as done
        }
    }, [isPageLoad]);
















    const removeHtmlTags = (htmlString) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlString;
        return tempElement.textContent || tempElement.innerText;
    };



    const getClassForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'not-submit-style';
            case 'D':
                return 'denied-style';
            case 'P':
                return 'paid-style';
            case 'F':
                return 'forwarded-style';
            case 'R':
                return 'rejected-style';
            default:
                return '';
        }
    };

    const getTitleForClaimStatus = (claimStatusFlag) => {
        const cleanClaimStatusFlag = removeHtmlTags(claimStatusFlag);
        switch (cleanClaimStatusFlag) {
            case 'N':
                return 'Not-Billed';
            case 'D':
                return 'Denied';
            case 'P':
                return 'Paid';
            case 'F':
                return 'Forwarded';
            case 'R':
                return 'Rejected';
            default:
                return '';
        }
    };




    function getTooltip(html) {
        const match = html.match(/data-title=['"]([^'"]+)['"]/);
        return match ? match[1] : '';
    }


    // New function to update "Select All" checkbox state based on individual checkboxes
    const updateSelectAllCheckbox = () => {
        const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));
        const someSelected = selectedRows.length > 0 && !allSelected;

        // Update the "Select All" checkbox based on individual checkboxes
        setSelectAllChecked(allSelected);

    };

    // State for "Select All" checkbox
    const [selectAllChecked, setSelectAllChecked] = useState(false);


    // Use useEffect to update "Select All" checkbox state whenever selectedRows changes
    useEffect(() => {
        updateSelectAllCheckbox();
    }, [selectedRows]);



    useEffect(() => {

        return () => setSelectedPolicyRows([]);
    }, []);


    useEffect(() => {

        setSelectAllChecked(selectedPolicyRows.length > 0);
    }, [selectedPolicyRows]);





    const handleSelectInsuranceAllChange = () => {



        const allSelected = tableDetails.every((_, index) => insuranceAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setInsuranceAllCheckbox([]);
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));

        }
    };




    const handleInsuranceRowCheckbox = (index, item) => {

        setClaimID(item.ClaimId)


        if (insuranceAllCheckbox.includes(index)) {
            // If the row is already selected, unselect it
            setInsuranceAllCheckbox(insuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));
            setSelectedInsRows((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== index));
        } else {
            // If the row is not selected, select it
            setInsuranceAllCheckbox([...insuranceAllCheckbox, index]);
            setSelectedInsRows((prevSelectedRows) => [...prevSelectedRows, index]);
        }
    };





    const handleSelectSecInsuranceAllChange = () => {

        const allSelected = tableDetails.every((_, index) => SecInsuranceAllCheckbox.includes(index));

        if (allSelected) {
            // Deselect all checkboxes
            setSecInsuranceAllCheckbox([]);
            setSelectedRows([]);
        } else {
            // Select all checkboxes
            setSecInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

            setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));

        }
    };


    const handleSecInsuranceCheckboxChange = (index) => {

        if (SecInsuranceAllCheckbox.includes(index)) {

            setSecInsuranceAllCheckbox(SecInsuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));
            setSelectedSecInsuranceRows((prevSelectedRows) => prevSelectedRows.filter((selectedRow) => selectedRow !== index));
        } else {

            setSecInsuranceAllCheckbox([...SecInsuranceAllCheckbox, index]);
            setSelectedSecInsuranceRows((prevSelectedRows) => [...prevSelectedRows, index]);
        }
    }



    useEffect(() => {

        return () => setSelectedWriteOffRows([]);
    }, []);


    useEffect(() => {

        setSelectAllWriteOffChecked(selectedWriteOffRows.length > 0);
    }, [selectedWriteOffRows]);


    const handleWriteOffSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedWriteOffRows.includes(index));
        setSelectAllWriteOffChecked((prevChecked) => !prevChecked);

        if (allSelected) {
            // Deselect all checkboxes
            setSelectedWriteOffRows([]);
        } else {
            // Select all checkboxes
            setSelectedWriteOffRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleWriteOffRowCheckboxChange = (index) => {

        if (selectedWriteOffRows.includes(index)) {
            setSelectedWriteOffRows(selectedWriteOffRows.filter((selectedRow) => selectedRow !== index));

        } else {
            setSelectedWriteOffRows([...selectedWriteOffRows, index]);

        }
        setSelectAllWriteOffChecked(false);
    }



    useEffect(() => {

        return () => setSelectedAdminWriteRows([]);
    }, []);

    useEffect(() => {

        setSelectAllAdminWriteChecked(selectedAdminWriteRows.length > 0);
    }, [selectedAdminWriteRows]);





    const handleAdminSelectAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedAdminWriteRows.includes(index));
        setSelectAllAdminWriteChecked((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedAdminWriteRows([]);
        } else {
            // Select all checkboxes
            setSelectedAdminWriteRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleAdminRowCheckboxChange = (index) => {

        if (selectedAdminWriteRows.includes(index)) {
            setSelectedAdminWriteRows(selectedAdminWriteRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedAdminWriteRows([...selectedAdminWriteRows, index]);
        }
        setSelectAllAdminWriteChecked(false);
    }


    useEffect(() => {

        return () => setSelectedResubmitRows([]);
    }, []);



    useEffect(() => {

        setSelectAllResubmit(selectedResubmitRows.length > 0);
    }, [selectedResubmitRows]);


    const handleResubmitAllChange = () => {
        const allSelected = tableDetails.every((_, index) => selectedResubmitRows.includes(index));
        setSelectAllResubmit((prevChecked) => !prevChecked);
        if (allSelected) {
            // Deselect all checkboxes
            setSelectedResubmitRows([]);
        } else {
            // Select all checkboxes
            setSelectedResubmitRows(Array.from({ length: tableDetails.length }, (_, index) => index));
        }


    };



    const handleReSubmitCheckboxChange = (index) => {

        if (selectedResubmitRows.includes(index)) {
            setSelectedResubmitRows(selectedResubmitRows.filter((selectedRow) => selectedRow !== index));
        } else {
            setSelectedResubmitRows([...selectedResubmitRows, index]);
        }
        setSelectAllResubmit(false);
    }






    const handleOpenModal = () => {


        setShowConfirmSaveModal(true);

    };







    const handleCloseModals = () => {
        // Close all modals

        setShowConfirmSaveModal(false);

        setShowVerifiedSaveModal(false);
        setShowSelectErrorModal(false);
        setCloseClaimsModal(false);
        setShowServiceErrorModal(false);
        setShowFaxModal(false);
        setShowDataModal(false)
        setShowCopaySuccessModal(false)

    };



    const formatDOSDate = (dateString) => {


        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
        });
    };


    const formatSubmitDate = (dateString) => {
        if (!dateString) {
            return ""; // or any default value you want to display for null dates
        }

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {
            return "Invalid Date"; // handle cases where the date string is not valid
        }

        return date.toLocaleDateString("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
    };




    //Saved all Claim CPT AdminWriteOffCharges

    const handleSaveClaimCPTAdminWriteOffCharges = async () => {


        const selectedDataArray = [];

        const updatedRecords = [...displayedRecords];

        for (const rowIndex of selectedAdminWriteRows) {
            const item = updatedRecords[rowIndex];

            item.AdminWriteOff = item.totalcharge;
            const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

            const selectedData = {

                ClaimID: item.ClaimId,
                AdminWriteOffValue: item.AdminWriteOff,
                PracticeID: userPracticeID,
                CPTcode: item.CPTOld,
                DOS: formattedClaimDOS,
                TransactionCode: selectedTransactionCode



            }



            selectedDataArray.push(selectedData)


        }


        var inputStruct = {

            SelectedClaims: selectedDataArray,

            LoggedInUserDetails: userData


        };

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };

        myInput = JSON.stringify(myInput);


        try {


            const response = await fetch(APIConstants.BASE_URL + ClaimStatusConstants.SaveClaimCPTAdminWriteOffCharges, {
                method: 'POST',


                headers: {

                    'Accept': 'application/json',
                    'Content-Type': 'application/json'

                },

                body: myInput
            })


            if (response.ok) {
                const responseData = await response.json();


                const parsedData = JSON.parse(responseData.d);

                setUpdatedTableData(parsedData)


                setShowConfirmSaveModal(false)



            } else {
                console.error('Error sending data to the API');
                setSavedRowCount(savedRowCount + selectedRows.length);

            }


            setSelectedRows([]);


        } catch (error) {
            console.error('An error occurred:', error);

        }

    }



    const handleOpenVerifiedModal = (item) => {
        setSelectedVerifiedData('');
        if (item.isVerified) {

            setSavingData(true);
            return;
        }


        setClaimId(item.ClaimId);
        setCptCode(item.CPTOld);
        const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

        setDos(formattedClaimDOS)

        setShowVerifiedSaveModal(true);
        setSavingData(true);

    }


    //Saved all Verified  data
    const handleSaveVerifiedData = () => {
        setSavingData(false);



        setSelectedVerifiedData('');

        var inputStruct =
        {
            sPracticeID: userPracticeID,
            sClaimID: claimId,
            Comments: selectedVerifiedData,
            DOS: dos,
            CPTCode: cptCode,
            LoggedInUserDetails: userData
        }

        var myInput = { sInputJSON: JSON.stringify(inputStruct) };
        var myInputData = JSON.stringify(myInput);

        const response = fetch(APIConstants.BASE_URL + ClaimStatusConstants.SaveVerifiedData, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInputData
        })

            .then((response) => response.json())
            .then((data) => {

                const parsedData = JSON.parse(data.d);


                setSavingData(true);


                const filteredClaims = displayedRecords.filter((claim) => {
                    if (claim.ClaimId == claimId) {
                        claim.isVerified = true;

                    }

                    return true;
                });

                setDisplayedRecords(filteredClaims);
                setShowVerifiedSaveModal(false);


            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };




    useEffect(() => {
        setAllClaims(tableDetails);
        setCategoryFilteredClaims(tableDetails);
        setDisplayedRecords(tableDetails);
    }, [tableDetails]);









    useEffect(() => {
        const toLower = val => (typeof val === 'string' ? val.toLowerCase() : val?.toString().toLowerCase());

        const matches = (field, searchVal) =>
            searchVal ? toLower(field)?.includes(searchVal.toLowerCase()) : true;

        const matchesStartsWith = (field, searchVal) =>
            searchVal ? toLower(field)?.startsWith(searchVal.toLowerCase()) : true;

        const matchesNumberField = (field, searchVal) =>
            searchVal
                ? (searchVal === '0' ? field === 0 : toLower(field)?.includes(searchVal.toLowerCase()))
                : true;

        const filteredData = categoryFilteredClaims.filter(item => {
            const dosDate = formatDOSDate(item.ClaimDOS);
            const dobDate = formatDOSDate(item.DOB);
            const submitDate = formatSubmitDate(item.SubmitDate);
            const secSubmitDate = formatSubmitDate(item.SecClaimSubmiDate);
            const paymentChequeDate = formatSubmitDate(item.PaymentChequeDate);
            const secCPTChequeDate = formatSubmitDate(item.SecCPTChequeDate);

            return (
                matches(dosDate, searchByDOS) &&
                matches(item.LocationNickname, searchByLocation) &&
                matches(item.ClaimId, searchByClaim) &&
                matchesStartsWith(item.LastName, searchByPatient) &&
                matches(dobDate, searchByDOB) &&
                matches(item.InsCompNickName, searchByInsurance) &&
                matches(item.SecInsCompNickName, searchBySecInsurance) &&
                matches(item.CPTOld, searchByCPT) &&
                matchesNumberField(item.totalcharge, searchByTotalCharge) &&
                matchesNumberField(item.Adjustment, searchByAdjustmentAmt) &&
                matchesNumberField(item.SecPendingAmt, searchBySecPendingAmt) &&
                matches(submitDate, searchBySubmitdate) &&
                matches(secSubmitDate, searchBySecSubmitdate) &&
                matchesNumberField(item.claimbln, searchByBalance) &&
                matches(item.ClearingHouseName, searchByClearingHouse) &&
                matchesNumberField(item.recvdCharge, searchByRcvdCharge) &&
                matchesNumberField(item.SecrecvdCharge, searchBySecRcvdCharge) &&
                matchesNumberField(item.Deductible, searchByDeductible) &&
                matchesNumberField(item.PatientAmount, searchByPatientRes) &&
                matchesNumberField(item.WriteOffAmount, searchByWriteOffValue) &&
                matchesNumberField(item.AdminwriteOff, searchByAdminWriteOffValue) &&
                matches(item.PaymentChqueNo, searchByCheckNum) &&
                matches(paymentChequeDate, searchByCheckDate) &&
                matches(item.PayerRefNumber, searchByPayerRef) &&
                matches(item.SecCPTChequeNumber, searchBySecCheckNum) &&
                matches(secCPTChequeDate, searchBySecCheckDate) &&
                matches(item.SecPayerclaimRefNumber, searchBySecPayerRef) &&
                matches(item.UpdaterName, searchByUpdatedBy) &&
                matches(item.SubmitterName, searchBySubmittedBy) &&
                matches(item.providername, searchByProvider) &&
                matches(removeHtmlTags(item.ClaimStatusFlag), searchByStatus)
            );
        });

        const hasSearch =
            searchByDOS || searchByPatient || searchByDOB || searchByInsurance || searchByClaim || searchByProvider ||
            searchBySecInsurance || searchByAdjustmentAmt || searchBySecPendingAmt || searchByLocation ||
            searchByCPT || searchByTotalCharge || searchByRcvdCharge || searchByWriteOffValue ||
            searchByAdminWriteOffValue || searchBySubmitdate || searchBySecSubmitdate ||
            searchBySecRcvdCharge || searchBySecCheckNum || searchBySecCheckDate ||
            searchBySecPayerRef || searchByDeductible || searchByPatientRes || searchByUpdatedBy || searchBySubmittedBy ||
            searchByBalance || searchByCheckNum || searchByCheckDate || searchByStatus || searchByPayerRef || searchByClearingHouse;

        setDisplayedRecords(hasSearch ? filteredData : categoryFilteredClaims);

    }, [
        searchByDOS, searchByPatient, searchByDOB, searchByInsurance, searchByClaim, searchByProvider,
        searchByCPT, searchBySecInsurance, searchByAdjustmentAmt, searchBySecPendingAmt, searchByTotalCharge,
        searchByRcvdCharge, searchBySecRcvdCharge, searchByWriteOffValue, searchByAdminWriteOffValue, searchByLocation,
        searchBySubmitdate, searchBySecSubmitdate, searchBySecCheckNum, searchBySecCheckDate, searchBySecPayerRef,
        searchByDeductible, searchByPatientRes, searchByUpdatedBy, searchBySubmittedBy, searchByBalance, searchByCheckNum,
        searchByCheckDate, searchByStatus, searchByPayerRef, searchByClearingHouse,
        categoryFilteredClaims
    ]);









    const ClosclaimWithCPT = async () => {


        if (selectedWriteOffRows.length === 0) {
            // Show error modal if no rows are selected

            setShowSelectErrorModal(true);


        } else {



            const selectedDataArray = [];


            for (const rowIndex of selectedWriteOffRows) {
                const item = displayedRecords[rowIndex];


                const formattedClaimDOS = formatDOSDate(item.ClaimDOS);

                const selectedData = {

                    ClaimID: item.ClaimId,
                    PracticeID: userPracticeID,
                    iIsCompClaim: 0,
                    CPTcode: item.CPTOld,
                    DOS: formattedClaimDOS,


                }



                selectedDataArray.push(selectedData)


            }


            var inputStruct = {

                JsonDataArr: selectedDataArray,

                LoggedInUserDetails: userData


            };

            var myInput = { sInputJSON: JSON.stringify(inputStruct) };

            myInput = JSON.stringify(myInput);


            try {


                const response = await fetch(APIConstants.BASE_URL + ClaimStatusConstants.CloseClaimWithCPT, {
                    method: 'POST',


                    headers: {

                        'Accept': 'application/json',
                        'Content-Type': 'application/json'

                    },

                    body: myInput
                })


                if (response.ok) {
                    const responseData = await response.json();


                    const parsedData = JSON.parse(responseData.d);

                    setUpdatedTableData(parsedData)


                    setShowSuccessModal(true);



                } else {
                    console.error('Error sending data to the API');


                }



            } catch (error) {
                console.error('An error occurred:', error);

            }

        }
    }








    //saved the notes message 

    const UpdateClaimNotes = (inputText, item) => {

        item.ClaimNotes = inputText;

        const objClaim = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            UpdatedBy: userData.userID,
            ClaimNotes: inputText,
            FirstName: item.FirstName,
            LastName: item.LastName,

        }


        const myInput = JSON.stringify(JSON.stringify({ 'objClaim': objClaim }))


        const response = fetch(APIConstants.BASE_URL_BILLING + PostingpaymentsConstants.UpdateClaimNotes, {
            method: 'POST',

            headers: {

                'Accept': 'application/json',
                'Content-Type': 'application/json'

            },

            body: myInput
        })

            .then((response) => response.json())
            .then((data) => {



                setClaimNotes((prevClaimNotes) =>
                    prevClaimNotes.map((existingItem) =>
                        existingItem === item
                            ? {
                                ...existingItem,
                                ClaimNotes: inputText,
                            }
                            : existingItem
                    )
                );



            })
            .catch((error) => {
                console.error('An error occurred:', error);

            })



    };





    //Check Eligiblity






    const handleCheckeligibility = async (e, rowIndex) => {


        if (selectedPolicyRows.length == 0) {
            setShowSelectErrorModal(true)
            return;
        }


        setRowState((prevState) => ({
            ...prevState,
            [claimID]: { isLoading: true, isHidden: true, showIcon: true }
        }));



        const selectedDataArray = [];

        for (const rowIndex of selectedPolicyRows) {
            const item = filteredTableDetails[rowIndex] || filteredTableDetails[rowIndex];
            setClaimID(item.ClaimId);
            setShowSelectErrorModal(false)


            setIsLoading(true);

            const eligibilityDOS = formatDOSDate(item.ClaimDOS);


            var InsCountryId = item.PrimaryIns
            if (InsCountryId == null) {
                InsCountryId = ""
            }

            var PayerID = item.InsPayerID
            if (PayerID == null) {
                PayerID = ""
            }



            var inputStruct = {

                "PatientID": item.PatientID,
                "PracticeID": userPracticeID,
                "PolicyNumber": item.PolicyNumber + "",
                "DOS": eligibilityDOS,
                "RowIndex": rowIndex


            };
        }


        var objPatientDetails = {
            'objPatientDetails': inputStruct
        }
        var myInput = JSON.stringify(objPatientDetails);

        var myInput = JSON.stringify(objPatientDetails);
        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${myInput}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })

            .then((response) => {
                if (response.status != 200) { console.log("response.status", response.status); }
                else return response.json();
            })


            .then((data) => {


                const responseData = data
                const parsedData = JSON.parse(responseData);


                setRowState((prevState) => ({
                    ...prevState,
                    [claimID]: { isLoading: false, isHidden: false, showIcon: true },
                }));


                setCheckEligibility(parsedData);
                var RowIndex = parsedData.RowIndex;
                var InsStatus = parsedData.InsStatus;
                setIsInStatus(parsedData.InsStatus);
                var EligibilityError = parsedData.EligibilityError;




                const payerIDElement = document.querySelector(`.payer${RowIndex}`);


                const filteredClaims = filteredTableDetails.filter((item) => {
                    if (item.ClaimId == claimID) {
                        if (payerIDElement) {
                            if (parsedData.InsStatus === "Active") {
                                payerIDElement.style.color = 'green';
                            } else {
                                payerIDElement.style.color = 'red';
                            }
                        }
                    }


                    return true;
                });

                setFilteredTableDetails(filteredClaims);






            }).catch((error) => {
                console.error('An error occurred:', error);

                setRowState((prevState) => ({
                    ...prevState,
                    [claimID]: { isLoading: false, isHidden: false, showIcon: true },
                }));



            })

    }





    const handleSecCheckeligibility = async (e, rowIndex) => {

        try {



            const selectedDataArray = [];

            for (const rowIndex of selectedSecInsuranceRows) {
                const item = displayedRecords[rowIndex] || displayedRecords[rowIndex];

                // setIsLoading(true);

                const eligibilityDOS = formatDOSDate(item.ClaimDOS);


                var InsCountryId = item.PrimaryInsurance
                if (InsCountryId == null) {
                    InsCountryId = ""
                }

                var PayerID = item.SecPayerID
                if (PayerID == null) {
                    PayerID = ""
                }


                var inputStruct = {


                    "PayerID": PayerID + "",
                    "sIns_PolicyNumber": item.PolicyNumber + "",
                    "patientID": item.PatientId,
                    "sInsuredFName": item.FirstName,
                    "sInsuredLName": item.LastName,
                    "sInsuredStateName": item.InsuredStateName + "",
                    "sInsuredDOB": formatDOSDate(item.DOB) + "",
                    "sInsCoID": InsCountryId,
                    "EligibilityDOS": eligibilityDOS + "",
                    "EligibilityRowIndex": rowIndex,
                    "LoggedInUserDetails": userData



                };
            }
            var myInput = { sInputJSON: JSON.stringify(inputStruct) };

            myInput = JSON.stringify(myInput);


            try {


                const response = await fetch(APIConstants.BASE_URL + CommonAPIConstants.CheckPatientEligibility, {
                    method: 'POST',


                    headers: {

                        'Accept': 'application/json',
                        'Content-Type': 'application/json'

                    },

                    body: myInput
                })


                if (response.ok) {
                    const responseData = await response.json();


                    const parsedData = JSON.parse(responseData.d);

                    setCheckEligibility(parsedData)


                    if (checkEligibility.length > 0) {
                        var RowIndex = checkEligibility[0].RowIndex;
                        var InsStatus = checkEligibility[0].InsStatus;
                        setIsInStatus(InsStatus);
                        var EligibilityError = checkEligibility[0].EligibilityError;
                    }



                    const payerIDElement = document.querySelector(`.payer-id-${RowIndex}`);

                    if (payerIDElement) {
                        if (InsStatus === "Active") {
                            payerIDElement.style.color = 'green';
                        } else {
                            payerIDElement.style.color = 'red';
                        }
                    }




                } else {
                    setCheckEligibility([]);
                    console.error('Error sending data to the API');


                }



            } catch (error) {
                console.error('An error occurred:', error);

            }
        } finally {
            setIsLoading(false);

        }

    }



    const handleRowClick = (index) => {
        setActiveRow(index);
        setHighlightCPTs([]);
    };






    //Filtered the data based on Status in MainTable


    const handleStatusFilterChange = (statusInt) => {
        setStatusFilter(statusInt);


        const filteredRecords = tableDetails.filter((item) => {
            const cleanClaimStatusFlag = removeHtmlTags(item.ClaimStatusFlag);
            switch (statusInt) {
                case 0:
                    return cleanClaimStatusFlag === 'N';
                case 1:
                    return cleanClaimStatusFlag === 'P';
                case 2:
                    return cleanClaimStatusFlag === 'R';
                case 5:
                    return cleanClaimStatusFlag === 'F';
                case 9:
                    return cleanClaimStatusFlag === 'D';

                case 10:
                    return cleanClaimStatusFlag === "P0";
                case 11:
                    return cleanClaimStatusFlag === "S0";
                default:
                    return false;
            }
        });

        setDisplayedRecords(filteredRecords);
    };






    const tableCountRef = useRef('');


    const handleCountPrint = () => {
        if (tableCountRef.current) {


            const tableHTML = tableCountRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Claim Status</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #1a9b8c;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 14px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 14px;
                    color: white !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A4 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 20px !important;
                      color: black;
                      
                    }

                     .input-date{
                      width: 70px !important;
                      color: black;
                      
                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
        } else {
            console.error("Table reference is not set.");
        }
    };




    const exportToCountExcel = () => {
        const pagename = 'ClaimStatus';
        const table = tableCountRef.current;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');

                }
            })
            .catch(error => {
                console.error('Export to Excel failed', error);
            });
    };






    const exportToCountPDF = () => {
        const pagename = 'ClaimStatus';
        const table = tableCountRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json())
            .then(data => {


                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };



    const tableRef = useRef('');


    const handlePrint = () => {
        if (tableRef.current) {


            const tableHTML = tableRef.current.outerHTML;
            const printWindow = window.open("", "_blank");

            printWindow.document.writeln(`
            <html>
              <head>
                <title class="print-title">Claim Status</title>
                <style>
                  body {
                    font-family: Arial, sans-serif;
                    margin: 10px;
                    font-size: 15px;
                    color: #000;
                  }
      
                  .print-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                    color: #1a9b8c;
                  }
      
                  .table-container {
                    width: 100%;
                    overflow-x: auto;
                  }
      
                  table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: auto; 
                    word-wrap: break-word;
                  }
      
                  th, td {
                    border: 1px solid black;
                    padding: 5px;
                    text-align: left;
                    font-size: 14px;
                  }
      
                  th {
                    background-color: #f4f4f4;;
                    font-size: 14px;
                    color: white !important;
                    border: 1px solid black;
                    text-align: top;
                    transform-origin: left bottom;
                    height: 120px;
                    
                  }
                  td{
                      font-size:14px
                    }
      
                  @media print {
                    @page {
                      size: A4 landscape;
                      margin: 10mm;
                    }
      
                    .table-container {
                      overflow: visible !important;
                    }
      
                     .hide-on-print {
                      display: none !important;
                    }
      
                    
                    .input{
                      width: 20px !important;
                      color: black;
                      
                    }

                     .input-date{
                      width: 70px !important;
                      color: black;
                      
                    }

                   
                    .show-on-print {
                        width: 30px;
                    }

                    .print-label {

                       display: inline-block;
                        max-width: 40px; 
                        word-wrap: break-word;
                        white-space: normal !important;
                        overflow-wrap: break-word;
                        font-size: 12px;
                     }
                  }
      
                  body {
                      -webkit-print-color-adjust: exact;
                    }
                  }
                </style>
              </head>
              <body>
               
                <div class="table-container">${tableHTML}</div>
                <script>
                  window.onload = function() {
                    window.print();
                  };
                  window.onafterprint = function() {
                    window.close();
                  };
                </script>
              </body>
            </html>
          `);

            printWindow.document.close();
        } else {
            console.error("Table reference is not set.");
        }
    };


    const exportToExcel = () => {
        const pagename = 'ClaimStatus';
        const table = tableContainerRef.current;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExcelFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');

                }
            })
            .catch(error => {
                console.error('Export to Excel failed', error);
            });
    };





    const exportToPDF = () => {
        const pagename = 'ClaimStatus';
        const table = tableContainerRef.current.parentNode;
        let sPrintableData = table ? table.innerHTML : '';

        const vRegEx = new RegExp("gvClosedClaims", "");
        sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


        const PrintableDataDetails = {
            PrintableData: sPrintableData,
            PageName: pagename,
        };

        const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
        const InputJSON = JSON.stringify(InputJSONLevelOne);


        fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: InputJSON,
        })
            .then(response => response.json()) // Parse the response as JSON
            .then(data => {


                if (data && data[2]) {

                    const url = data[2];
                    window.open(url, '_blank');


                }
            })
            .catch(error => {
                console.error('Export to PDF failed', error);
            });
    };










    const GetProviderPDF = (item) => {

        const claimFilters = {
            PracticeID: userPracticeID,
            PatientID: item.PatientID,
            DOS: formatDOSDate(item.ClaimDOS),
            CPT: item.CPTOld
        };


        const sInputJSON = JSON.stringify({ objPatDetails: claimFilters });

        const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.CPTDcoument}?sInputJSON=${sInputJSON}`;

        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sAuthToken}`,
            }
        })

            .then(response => response.json()) // Parse the response as JSON
            .then(data => {

                //if (data.status==200) 
                {

                    const url = JSON.parse(data);
                    window.open(url.DocumentURL, '_blank');


                }
            })
            .catch(error => {
                console.error(' PDF failed', error);
            });
    };




    const handleLinkClick = (item) => {
        const url = `/#/new-encounter/${item.ClaimId}`;
        window.open(url, '_blank');
    };



    const handlePatLinkClick = (item) => {
        const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

        localStorage.setItem("statusPatientID", item.PatientID);

        window.open(url, '_blank');
    };










    useEffect(() => {
        const filteredData = claimFilterRecCountsTableData.filter(item =>
            (item.DOS && typeof item.DOS === 'string' ? item.DOS.toLowerCase().includes(searchByClaimDos.toLowerCase()) : true)


        );

        setClaimRecCountsTableData(
            searchByClaimDos ? filteredData : claimFilterRecCountsTableData
        );


        if (searchByClaimDos && filteredData.length > 0) {
            setShowDetails(true);
        } else {
            setShowDetails(false);
        }
    }, [searchByClaimDos, claimFilterRecCountsTableData]);







    const getRepeatedClaimIdsWithColors = (records) => {
        const claimIdCount = {};
        const claimIdColors = {};
        let toggleColor = true;

        records.forEach((item, index) => {
            if (claimIdCount[item?.ClaimId]) {
                claimIdCount[item?.ClaimId] += 1;
            } else {
                claimIdCount[item?.ClaimId] = 1;

                // Assign alternating colors to repeated ClaimId groups
                claimIdColors[item?.ClaimId] = toggleColor ? 'lightgrey' : 'gray';
                toggleColor = !toggleColor;
            }
        });

        return { claimIdCount, claimIdColors };
    };

    const { claimIdCount, claimIdColors } = getRepeatedClaimIdsWithColors(displayedRecords);



    const handleSort = (key, accessor) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...displayedRecords].sort((a, b) => {
            let aValue = accessor ? accessor(a) : a[key];
            let bValue = accessor ? accessor(b) : b[key];


            if (aValue == null) aValue = 0;
            if (bValue == null) bValue = 0;


            if (key.toLowerCase().includes('date') || key.toLowerCase().includes('dob') || key.toLowerCase().includes('dos')) {
                aValue = new Date(aValue);
                bValue = new Date(bValue);
            }

            else if (!isNaN(aValue) && !isNaN(bValue)) {
                aValue = parseFloat(aValue) || 0;
                bValue = parseFloat(bValue) || 0;
            }

            else if (typeof aValue === 'string') {
                aValue = aValue.toUpperCase();
                bValue = typeof bValue === 'string' ? bValue.toUpperCase() : '';
            }

            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
            return 0;
        });

        setSortConfig({ key, direction });
        setDisplayedRecords(sortedData);
    };




    const handleGetClaimTrnsDetails = async (item) => {

        setLoading(true);
        const input = {
            ClaimID: item.ClaimId,
            PracticeID: userPracticeID
        };

        const sInputJSON = JSON.stringify(input);
        const url = `${APIConstants.BASE_URL_BILLING}${TransactionLogsConstants.GetClaimTrnsDetails}?sInputJSON=${sInputJSON}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sAuthToken}`,
                }
            });

            if (!response.ok) {
                console.error('HTTP Error:', response.status);
                return [];
            }


            const parsedData = await response.json();


            const trnData = JSON.parse(parsedData)
            console.log("Response of" + TransactionLogsConstants.GetClaimTrnsDetails, trnData);
            setLoading(false);
            return trnData;



        } catch (error) {
            console.error('API Error:', error);
            return [];
        }
        finally {
            setLoading(false);
        }
    };





    const handleGetMouleAudits = async (item) => {

        setLoading(true);
        const input = {
            PracticeID: userPracticeID,
            DataID: item.ClaimId,
            Module: "Billing",
            SubModule: '',
            sFromDate: formatDOSDate(item.DOS),
            sToDate: formatDOSDate(item.DOS),
            PatientID: item.PatientID,
            UserID: userId,

        };

        const sInputJSON = JSON.stringify(input);
        const url = `${APIConstants.BASE_AUDIT_URL}${TransactionLogsConstants.GetMouleAudits}?sInputJSON=${sInputJSON}`;

        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sAuthToken}`,
                }
            });

            if (!response.ok) {
                console.error('HTTP Error:', response.status);
                return [];
            }


            const resData = await response.json();
            const parsedData = JSON.parse(resData)
            console.log("Response of" + TransactionLogsConstants.GetMouleAudits, parsedData);
            setLoading(false);
            return parsedData;

        } catch (error) {
            console.error('API Error:', error);
            return [];
        }
    };





    const toggleRowExpansion = async (rowIndex, item) => {


        const isExpanded = expandedRows[rowIndex];

        if (isExpanded) {
            setExpandedRows(prev => ({ ...prev, [rowIndex]: false }));
        } else {
            try {
                const [trnRes, auditRes] = await Promise.all([
                    handleGetClaimTrnsDetails(item),
                    handleGetMouleAudits(item)
                ]);

                setTransactionData(prev => ({
                    ...prev,
                    [rowIndex]: trnRes || [],
                }));

                setAuditData(prev => ({
                    ...prev,
                    [rowIndex]: auditRes || [],
                }));

                setExpandedRows(prev => ({ ...prev, [rowIndex]: true }));


            } catch (error) {
                console.error("Toggle row error:", error);
            }
        }
    };






    return (
        <>



            <div className='main-container' style={{ width: '100%', marginTop: '0px' }}>
                <div className='container-style'>

                    {loading && (
                        <div className="overlay">
                            <div className="spinner-container">
                                <div className="spinner-grow text-danger" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-warning" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="spinner-grow text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}




                    <div className="cs-view-bar">
                        <div className="cs-view-switcher">
                            <button className={`cs-view-tab${activeView === "claimInfo" ? " active" : ""}`} onClick={() => setActiveView("claimInfo")}><FontAwesomeIcon icon={faCircleUser} /> Claim Info</button>
                            <button className={`cs-view-tab${activeView === "payments" ? " active" : ""}`} onClick={() => setActiveView("payments")}><FontAwesomeIcon icon={faCreditCard} /> Payments</button>
                            <button className={`cs-view-tab${activeView === "notesWorkflow" ? " active" : ""}`} onClick={() => setActiveView("notesWorkflow")}><FontAwesomeIcon icon={faListCheck} /> Notes & Workflow</button>
                        </div>
                        <div className='d-flex mt-2' style={{ marginLeft: '20px' }}>
                            <FontAwesomeIcon style={{ cursor: 'pointer', fontSize: '1.5rem' }} onClick={handlePrint} icon={faPrint} />
                            <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', cursor: 'pointer', fontSize: '1.5rem' }} onClick={exportToExcel} icon={faFileExcel} />
                            <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', cursor: 'pointer', fontSize: '1.5rem' }} onClick={exportToPDF} icon={faFilePdf} />


                        </div>

                    </div>



                    <div className="table-container" ref={tableRef}>
                        <table className="fixed-header table table-hover border-secondary table-bordered border responsive mt-1 " ref={tableContainerRef}>

                            <thead>
                                {activeView === "claimInfo" && (
                                    <tr className='align-top'>

                                        <th className=' border-white col-sm col-th  text-white sticky-col-1 ' style={{ backgroundColor: '#1a9b8c', width: '50px', }}>#</th>
                                        <th className=' border-white col col-th-style  text-white sticky-col-2 ' style={{ backgroundColor: '#1a9b8c', width: '100px' }} >
                                            <Link className='text-white' onClick={() => handleSort('LocationNickname')}>Location</Link>
                                            <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByLocation}
                                                onChange={(e) => setSearchByLocation(e.target.value)}
                                            />
                                        </th>
                                        <th className=' border-white col col-th-style  text-white sticky-col-3' style={{ backgroundColor: '#1a9b8c', width: '120px' }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimDOS')}>DOS</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col col-th-style  text-white sticky-col-4' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimId')}>Claim ID</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByClaim}
                                                onChange={(e) => setSearchByClaim(e.target.value)}
                                            />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white sticky-col-5' style={{ backgroundColor: '#1a9b8c', }}>
                                            <Link className='text-white hide-on-print' onClick={() => handleSort('FullName', (item) => `${item.LastName}, ${item.FirstName}`)}>Patient Name</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Patient
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                type='text'
                                                placeholder='Search'
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)}
                                            />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c', }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimConType')}>BH/SUD</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                type='text'
                                                placeholder='Search'

                                            />

                                        </th>

                                        <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c', width: '120px' }}>
                                            <Link className='text-white' onClick={() => handleSort('DOB')}>DOB</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                type='text'
                                                placeholder='Search'
                                                value={searchByDOB}
                                                onChange={(e) => setSearchByDOB(e.target.value)}
                                            />
                                        </th>


                                        <th className=' border-white col col-th-style  text-white PriInsData' >
                                            <a className='hide-on-print' style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PolicyNumber')}>Insurance(Pri)</a>

                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Ins
                                                (Pri)
                                            </span>
                                            <br />

                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByInsurance}
                                                onChange={(e) => setSearchByInsurance(e.target.value)}
                                            />

                                            <br />

                                            <button className='btn-style3 mt-2 hide-on-print' onClick={(e) => handleCheckeligibility(e)}>Check</button>

                                            <input className='hide-on-print' style={{ float: 'right', marginTop: '15px' }} type='checkbox'

                                                onChange={() => handleSelectInsuranceAllChange('all')}
                                            />


                                        </th>

                                        <th className=' border-white col col-th-style  text-white SecInsData'>
                                            <a className='hide-on-print' style={{ cursor: 'pointer', color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecInsPolicyNumber')}>Insurance(Sec)</a>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Ins
                                                (Sec)
                                            </span>
                                            <br />

                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchBySecInsurance}
                                                onChange={(e) => setSearchBySecInsurance(e.target.value)}
                                            />

                                            <br />

                                            <button className='btn-style3 mt-2 hide-on-print' onClick={(e) => handleSecCheckeligibility(e)} >Check</button>

                                            <input className='hide-on-print' style={{ float: 'right', marginTop: '15px' }} type='checkbox'
                                                onChange={() => handleSelectSecInsuranceAllChange('all')}
                                            />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#1a9b8c' }}>
                                            Billing NPI
                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white thead' onClick={() => handleSort('ClearingHouseName')}>Clearing House</Link>
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByClearingHouse}
                                                onChange={(e) => setSearchByClearingHouse(e.target.value)}
                                            />
                                        </th>




                                        <th className=' border-white col col-th-style  text-white PriInsData'>
                                            <label ></label>
                                            <Link className='thead' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SubmitDate')}>Submit Date(Pri)</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchBySubmitdate}
                                                onChange={(e) => setSearchBySubmitdate(e.target.value)}
                                            />
                                        </th>


                                        <th className=' border-white col col-th-style  text-white SecInsData'>

                                            <Link className='thead' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecClaimSubmiDate')}>Submit Date(Sec)</Link>

                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchBySecSubmitdate}
                                                onChange={(e) => setSearchBySecSubmitdate(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white' style={{ backgroundColor: '#1a9b8c' }}>
                                            <label className='print-label '>Status</label>

                                            <br />
                                            <div className='hide-on-print'>
                                                <label className={`not-submit-style ${statusFilter === 0 ? 'active' : ''}`} title='Not-Submitted' onClick={() => handleStatusFilterChange(0)}>N</label>
                                                <label className={`denied-style ${statusFilter === 9 ? 'active' : ''}`} title='Denied' onClick={() => handleStatusFilterChange(9)}>D</label>
                                                <label className={`paid-style ${statusFilter === 1 ? 'active' : ''}`} title='Paid' onClick={() => handleStatusFilterChange(1)}>P</label>
                                                <label className={`forwarded-style ${statusFilter === 5 ? 'active' : ''}`} title='Forwarded' onClick={() => handleStatusFilterChange(5)}>F</label>
                                                <label className={`rejected-style ${statusFilter === 2 ? 'active' : ''}`} title='Rejected' onClick={() => handleStatusFilterChange(2)}>R</label>
                                                <label className={`NonPaidClaims ${statusFilter === 10 ? 'active' : ''}`} title='NonPaidClaims' onClick={() => handleStatusFilterChange(10)}>P0</label>
                                                <label className={`NonPaidClaims ${statusFilter === 11 ? 'active' : ''}`} title='NonPaidClaims' onClick={() => handleStatusFilterChange(11)}>S0</label>
                                            </div>
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByStatus}
                                                onChange={(e) => setSearchByStatus(e.target.value)}
                                            />

                                        </th>


                                        <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('CPTOld')}>CPT</Link>
                                            <br />
                                            <div className=' unpaid-claims'>R</div>

                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px', marginTop: '2px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByCPT}
                                                onChange={(e) => setSearchByCPT(e.target.value)}
                                            />


                                        </th>

                                        <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c', width: '100px' }}>
                                            <Link className='text-white' onClick={() => handleSort('Units')}>Units</Link>
                                        </th>



                                    </tr>
                                )}

                                {activeView === "payments" && (

                                    <tr className='align-top'>

                                        <th className=' border-white col-sm col-th  text-white sticky-col-1 ' style={{ backgroundColor: '#1a9b8c', width: '50px', }}>#</th>
                                        <th className=' border-white col col-th-style  text-white sticky-col-2 ' style={{ backgroundColor: '#1a9b8c', width: '100px' }} >
                                            <Link className='text-white' onClick={() => handleSort('LocationNickname')}>Location</Link>
                                            <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByLocation}
                                                onChange={(e) => setSearchByLocation(e.target.value)}
                                            />
                                        </th>
                                        <th className=' border-white col col-th-style  text-white sticky-col-3' style={{ backgroundColor: '#1a9b8c', width: '120px' }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimDOS')}>DOS</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col col-th-style  text-white sticky-col-4' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimId')}>Claim ID</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByClaim}
                                                onChange={(e) => setSearchByClaim(e.target.value)}
                                            />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white sticky-col-5' style={{ backgroundColor: '#1a9b8c', }}>
                                            <Link className='text-white hide-on-print' onClick={() => handleSort('FullName', (item) => `${item.LastName}, ${item.FirstName}`)}>Patient Name</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Patient
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                type='text'
                                                placeholder='Search'
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)}
                                            />

                                        </th>



                                        <th className=' border-white col col-th-style  text-white' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white hide-on-print' onClick={() => handleSort('totalcharge')}>Total Charge</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Total
                                                Charge
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByTotalCharge}
                                                onChange={(e) => setSearchByTotalCharge(e.target.value)}
                                            />
                                        </th>



                                        <th className=' border-white col-sm col-th text-white PriInsData'>

                                            <Link className='hide-on-print' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('recvdCharge')}>Charge Recieved(Pri)</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold', width: '30px' }}>
                                                charge
                                                Recvd
                                                (Pri)
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByRcvdCharge}
                                                onChange={(e) => setSearchByRcvdCharge(e.target.value)}
                                            />

                                        </th>


                                        <th className=' border-white col-sm col-th text-white SecInsData'>

                                            <Link className='hide-on-print' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecrecvdCharge')}>Charge Recieved(Sec)</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold', width: '30px' }}>
                                                charge
                                                Recvd
                                                (Sec)
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchBySecRcvdCharge}
                                                onChange={(e) => setSearchBySecRcvdCharge(e.target.value)}
                                            />

                                        </th>


                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#f1f1c4', fontSize: '1.1rem' }}>

                                            <Link className='hide-on-print' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('Adjustment')}>Contractual Adjustment</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Adj.
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                defaultValue={searchByAdjustmentAmt}
                                                onChange={(e) => setSearchByAdjustmentAmt(e.target.value)}
                                            />

                                        </th>


                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: 'lightyellow', fontSize: '1.1rem' }}>

                                            <Link className='hide-on-print' style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecPendingAmt')}>Secondary Pending</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Pen
                                                ding
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                defaultValue={searchBySecPendingAmt}
                                                onChange={(e) => setSearchBySecPendingAmt(e.target.value)}
                                            />

                                        </th>


                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white hide-on-print' onClick={() => handleSort('Deductible')}>Deductible</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Dedu
                                                cti
                                                ble
                                            </span>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByDeductible}
                                                onChange={(e) => setSearchByDeductible(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('PatientAmount')}>Pat Res</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByPatientRes}
                                                onChange={(e) => setSearchByPatientRes(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('Copay')}>COPAY</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByCopay}
                                                onChange={(e) => setSearchByCopay(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white hide-on-print' onClick={() => handleSort('WriteOffAmount')}>Write-off</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Write
                                                off
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text'
                                                placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByWriteOffValue}
                                                onChange={(e) => setSearchByWriteOffValue(e.target.value)}
                                            />
                                            <br />
                                            <input type='checkbox'
                                                checked={selectAllWriteOffChecked}
                                                onChange={() => handleWriteOffSelectAllChange('all')} />
                                            <button className='btn-style3 hide-on-print' onClick={() => ClosclaimWithCPT()}>Close</button>

                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white hide-on-print' onClick={() => handleSort('AdminWriteOff')}>Admin Write-off</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Admin
                                                Write
                                                off
                                            </span>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByAdminWriteOffValue}
                                                onChange={(e) => setSearchByAdminWriteOffValue(e.target.value)}
                                            />

                                            <br />
                                            <input type='checkbox'
                                                checked={selectAllAdminWriteChecked}
                                                onChange={() => handleAdminSelectAllChange('all')} />
                                            <button className='btn-style3 hide-on-print' onClick={handleOpenModal}>Write-off</button>

                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('claimbln')}>Balance</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByBalance}
                                                onChange={(e) => setSearchByBalance(e.target.value)}
                                            />
                                        </th>


                                    </tr>
                                )}

                                {activeView === "notesWorkflow" && (
                                    <tr className='align-top'>

                                        <th className=' border-white col-sm col-th  text-white sticky-col-1 ' style={{ backgroundColor: '#1a9b8c', width: '50px', }}>#</th>
                                        <th className=' border-white col col-th-style  text-white sticky-col-2 ' style={{ backgroundColor: '#1a9b8c', width: '100px' }} >
                                            <Link className='text-white' onClick={() => handleSort('LocationNickname')}>Location</Link>
                                            <input style={{ width: '80px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByLocation}
                                                onChange={(e) => setSearchByLocation(e.target.value)}
                                            />
                                        </th>
                                        <th className=' border-white col col-th-style  text-white sticky-col-3' style={{ backgroundColor: '#1a9b8c', width: '120px' }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimDOS')}>DOS</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByDOS}
                                                onChange={(e) => setSearchByDOS(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col col-th-style  text-white sticky-col-4' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimId')}>Claim ID</Link>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByClaim}
                                                onChange={(e) => setSearchByClaim(e.target.value)}
                                            />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white sticky-col-5' style={{ backgroundColor: '#1a9b8c', }}>
                                            <Link className='text-white hide-on-print' onClick={() => handleSort('FullName', (item) => `${item.LastName}, ${item.FirstName}`)}>Patient Name</Link>
                                            <span className="show-on-print" style={{ color: 'black', fontWeight: 'bold' }}>
                                                Patient
                                            </span>
                                            <br />
                                            <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                                                className='hide-on-print'
                                                type='text'
                                                placeholder='Search'
                                                value={searchByPatient}
                                                onChange={(e) => setSearchByPatient(e.target.value)}
                                            />

                                        </th>


                                        <th className=' border-white col-sm col-th text-white PriInsData' >

                                            <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PaymentChqueNo')}>Check#(Pri)</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByCheckNum}
                                                onChange={(e) => setSearchByCheckNum(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white PriInsData'>

                                            <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PaymentChequeDate')}>Check Date(Pri)</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByCheckDate}
                                                onChange={(e) => setSearchByCheckDate(e.target.value)}

                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white PriInsData'>

                                            <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('PayerRefNumber')}>Payer Ref#(Pri)</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByPayerRef}
                                                onChange={(e) => setSearchByPayerRef(e.target.value)}

                                            />
                                        </th>



                                        <th className=' border-white col-sm col-th text-white SecInsData'>

                                            <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecCPTChequeNumber')}>Check#(Sec)</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                placeholder='Search'
                                                className='hide-on-print'
                                                value={searchBySecCheckNum}
                                                onChange={(e) => setSearchBySecCheckNum(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white SecInsData'>

                                            <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecCPTChequeDate')}>Check Date(Sec)</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchBySecCheckDate}
                                                onChange={(e) => setSearchBySecCheckDate(e.target.value)}

                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white SecInsData' >

                                            <Link style={{ color: 'black', fontWeight: 'bold' }} onClick={() => handleSort('SecPayerclaimRefNumber')}>
                                                Payer Ref#(Sec)
                                            </Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchBySecPayerRef}
                                                onChange={(e) => setSearchBySecPayerRef(e.target.value)}

                                            />
                                        </th>


                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('providername')}>Provider</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text'
                                                className='hide-on-print'
                                                placeholder='Search'
                                                value={searchByProvider}
                                                onChange={(e) => setSearchByProvider(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('UpdaterName')}>Updated By</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchByUpdatedBy}
                                                onChange={(e) => setSearchByUpdatedBy(e.target.value)}
                                            />
                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('SubmitterName')}>Submitted By</Link>
                                            <br />
                                            <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                                                className='hide-on-print'
                                                value={searchBySubmittedBy}
                                                onChange={(e) => setSearchBySubmittedBy(e.target.value)}
                                            />
                                        </th>




                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>Remarks
                                            <br />
                                            <input className='hide-on-print' style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'

                                            />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>Error Details
                                            <br />
                                            <input className='hide-on-print' style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'

                                            />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}><Link style={{ color: 'white' }}>Resubmit</Link>
                                            <input style={{ marginLeft: '3px' }} type='checkbox'
                                                checked={selectAllResubmit}
                                                onChange={() => handleResubmitAllChange('all')} />

                                        </th>

                                        <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#1a9b8c' }}>
                                            <Link className='text-white' onClick={() => handleSort('ClaimNotes')}>Notes</Link>

                                        </th>

                                    </tr>
                                )}
                            </thead>


                            <tbody >



                                {displayedRecords.length > 0 ? (
                                    displayedRecords.slice(0, visibleRecords).map((item, index) => {


                                        const isClaimIdRepeated = claimIdCount[item.ClaimId] > 1;
                                        const backgroundColor = isClaimIdRepeated ? claimIdColors[item.ClaimId] : '';


                                        const claimHx = item.ClaimHx;


                                        return (


                                            <tr

                                                className={
                                                    item.DataValidationMessage && activeRow !== index
                                                        ? ''
                                                        : activeRow === index
                                                            ? 'table-warning'
                                                            : highlightCPTs.some(cpt => cpt.toLowerCase() === extractCPTValue(item).toLowerCase())
                                                                ? 'table-warning'
                                                                : ''
                                                }


                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title={item.DataValidationMessage || ''}
                                                key={index}
                                                onClick={() => handleRowClick(index)}


                                            >

                                                {activeView === "claimInfo" && (
                                                    <>
                                                        <td className='table-bordered border border-white sticky-col-1' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                                                        <td className='table-bordered border border-white sticky-col-2' style={{ width: '100px' }}><label>{item.LocationNickname}</label></td>
                                                        <td className='table-bordered border border-white sticky-col-3' style={{ backgroundColor, width: '120px' }}>

                                                            {formatDOSDate(item.ClaimDOS)}</td>

                                                        <td className='table-bordered border border-white sticky-col-4'
                                                            style={{
                                                                backgroundColor: item.updatedby && item.UpdatedDateTime ? 'lightpink' : '',
                                                            }}
                                                        >

                                                            <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                                                                {item.ClaimId}
                                                            </span>


                                                            <span style={{ marginLeft: '10px' }} onClick={() => toggleRowExpansion(index, item)}>
                                                                <FontAwesomeIcon
                                                                    icon={expandedRows[index] ? faMinus : faPlus}
                                                                    style={{ cursor: 'pointer', fontSize: '18px', marginTop: '10px' }}
                                                                />
                                                            </span>


                                                            {expandedRows[index] && (

                                                                <>
                                                                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #ccc' }}>

                                                                        <strong>Transactions</strong>


                                                                        <table className="table table-hover border-secondary table-bordered table-info border" style={{ width: '100%', marginTop: '10px', fontSize: '15px' }}>
                                                                            <thead>
                                                                                <tr className='align-top border-secondary'>
                                                                                    <th>#</th>
                                                                                    <th>DOS</th>
                                                                                    <th>DOT</th>
                                                                                    <th>Claim ID</th>
                                                                                    <th>CPT</th>
                                                                                    <th>Transaction Code</th>
                                                                                    <th>Transaction</th>
                                                                                    <th>Total Amt</th>
                                                                                    <th>Insurance Amt</th>
                                                                                    <th>Patient Amt</th>
                                                                                    <th>DOP</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>


                                                                                {Array.isArray(transactionData[index]) && transactionData[index].length > 0 ? (

                                                                                    transactionData[index]?.map((item, txnIndex) => (
                                                                                        <tr key={txnIndex}>
                                                                                            <td>{txnIndex + 1}</td>
                                                                                            <td>{formatDOSDate(item.DOS)}</td>
                                                                                            <td>{formatDOSDate(item.TransactionAddedDate)}</td>
                                                                                            <td>{item.ClaimID}</td>
                                                                                            <td>{item.CPT}</td>
                                                                                            <td>{item.TransactionCode}</td>
                                                                                            <td>{item.TransactionCodeDescription}</td>
                                                                                            <td>{item.TransactionAmt}</td>
                                                                                            <td>{item.InsuranceAmt}</td>
                                                                                            <td>{item.PatientAmt}</td>
                                                                                            <td>{formatDOSDate(item.PostingDate)}</td>

                                                                                        </tr>

                                                                                    ))



                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={11}>No Records Found</td>
                                                                                    </tr>
                                                                                )}

                                                                                <tr className='table-secondary'>
                                                                                    <td colSpan={11}>
                                                                                        {(() => {
                                                                                            const patTotal = transactionData[index].reduce(
                                                                                                (sum, item) => sum + (parseFloat(item.PatientAmt) || 0),
                                                                                                0
                                                                                            );
                                                                                            const insTotal = transactionData[index].reduce(
                                                                                                (sum, item) => sum + (parseFloat(item.InsuranceAmt) || 0),
                                                                                                0
                                                                                            );
                                                                                            const total = patTotal + insTotal;

                                                                                            return (
                                                                                                <>
                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Pat Balance:</label>
                                                                                                    <label style={{ marginRight: '10px' }}>{patTotal.toFixed(2)}</label>

                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Insurance Balance:</label>
                                                                                                    <label style={{ marginRight: '10px' }}>{insTotal.toFixed(2)}</label>

                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Total Balance:</label>
                                                                                                    <label>{total.toFixed(2)}</label>
                                                                                                </>
                                                                                            );
                                                                                        })()}
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>



                                                                        </table>


                                                                    </div>


                                                                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #ccc' }}>

                                                                        <strong>Audit Log</strong>


                                                                        <table className="table table-hover border-secondary table-bordered table-info border" style={{ width: '100%', marginTop: '10px', fontSize: '15px' }}>
                                                                            <thead>
                                                                                <tr className='align-top border-secondary'>
                                                                                    <th>#</th>
                                                                                    <th>Description</th>
                                                                                    <th>Date</th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>


                                                                                {Array.isArray(auditData[index]) && auditData[index].length > 0 ? (

                                                                                    auditData[index]?.map((item, txnIndex) => (
                                                                                        <tr key={txnIndex}>
                                                                                            <td>{txnIndex + 1}</td>
                                                                                            <td>{item.AuditDescription}</td>
                                                                                            <td>{formatDOSDate(item.AuditDate)}</td>

                                                                                        </tr>
                                                                                    ))

                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={11}>No Records Found</td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>


                                                                    </div>


                                                                </>
                                                            )}




                                                        </td>



                                                        <td className='table-bordered border border-white sticky-col-5' style={{ backgroundColor }}>
                                                            <label className={`linkspan print-label ${item.EligibilityCheckCount > 0 ? 'EligibilityChecked' : 'EligibilityNotChecked'}`} onClick={() => handlePatLinkClick(item)}>
                                                                {item.LastName},{item.FirstName}

                                                            </label>
                                                        </td>

                                                        <td className='table-bordered border border-white'>

                                                            <label className={item.ClaimConType ? 'btnsud' : ''}>{item.ClaimConType}</label>

                                                        </td>
                                                        <td className='table-bordered border border-white' style={{ width: '120px' }}><label className='label-style' >{formatSubmitDate(item.DOB)}</label></td>
                                                        <td className='table-bordered border border-white'><label className='label-style'>{item.InsCompNickName}</label>
                                                            <br />
                                                            <label>{item.PayerID}</label>

                                                            <span className={`payer${index} print-label`}>
                                                                {item.PolicyNumber}
                                                            </span>


                                                            {rowState[item.ClaimId]?.isHidden && (
                                                                <FontAwesomeIcon
                                                                    style={{ marginLeft: '5px' }}
                                                                    icon={faSpinner}
                                                                    className={rowState[item.ClaimId]?.isLoading ? 'rotating-icon' : ''}
                                                                />
                                                            )}



                                                            <input type='checkbox' style={{ marginLeft: '5px' }} className='hide-on-print'
                                                                key={index}
                                                                checked={insuranceAllCheckbox.includes(index)}
                                                                onChange={() => handleInsuranceRowCheckbox(index, item)}

                                                            />

                                                        </td>
                                                        <td className='table-bordered border border-white' style={{ backgroundColor: '#f1f1c4 !important' }}>
                                                            <label className='label-style'>{item.SecInsCompNickName}</label>
                                                            <br />

                                                            <label>{item.SecPayerID}</label>

                                                            <span className={`payer-id-${index}`}>
                                                                {item.SecInsPolicyNumber}
                                                            </span>

                                                            <input type='checkbox' style={{ marginLeft: '5px' }} className='hide-on-print'
                                                                checked={SecInsuranceAllCheckbox.includes(index)}
                                                                onChange={() => handleSecInsuranceCheckboxChange(index)}
                                                            />

                                                        </td>

                                                        <td className='table-bordered border border-white'>{item.claim33a}</td>

                                                        <td className='table-bordered border border-white'><label>{item.ClearingHouseName}</label>
                                                        </td>

                                                        <td className='table-bordered border border-white'><label className='label-style'>{formatSubmitDate(item.SubmitDate)}</label></td>
                                                        <td className='table-bordered border border-white'><label className='label-style'>{formatSubmitDate(item.SecClaimSubmiDate)}</label></td>
                                                        <td className='table-bordered border border-white'>
                                                            <label title={getTooltip(item.PrimaryClaimStatus)} dangerouslySetInnerHTML={{ __html: item.PrimaryClaimStatus }}></label>
                                                            <label title={getTooltip(item.SecClaimStatus)} dangerouslySetInnerHTML={{ __html: item.SecClaimStatus }}></label>

                                                        </td>

                                                        <td className='table-bordered border border-white'><label className='unpaid-claims' style={{ backgroundColor: item.recvdCharge !== null ? 'lightgreen' : 'lightgray' }}>{item.CPTOld}</label>

                                                        </td>
                                                        <td className='table-bordered border border-white' style={{ width: '100px' }}><label>{item.Units}</label>

                                                        </td>

                                                    </>
                                                )}

                                                {activeView === "payments" && (
                                                    <>
                                                        <td className='table-bordered border border-white sticky-col-1' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                                                        <td className='table-bordered border border-white sticky-col-2' style={{ width: '100px' }}><label>{item.LocationNickname}</label></td>
                                                        <td className='table-bordered border border-white sticky-col-3' style={{ backgroundColor, width: '120px' }}>

                                                            {formatDOSDate(item.ClaimDOS)}</td>

                                                        <td className='table-bordered border border-white sticky-col-4'
                                                            style={{
                                                                backgroundColor: item.updatedby && item.UpdatedDateTime ? 'lightpink' : '',
                                                            }}
                                                        >

                                                            <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                                                                {item.ClaimId}
                                                            </span>


                                                            <span style={{ marginLeft: '10px' }} onClick={() => toggleRowExpansion(index, item)}>
                                                                <FontAwesomeIcon
                                                                    icon={expandedRows[index] ? faMinus : faPlus}
                                                                    style={{ cursor: 'pointer', fontSize: '18px', marginTop: '10px' }}
                                                                />
                                                            </span>


                                                            {expandedRows[index] && (

                                                                <>
                                                                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #ccc' }}>

                                                                        <strong>Transactions</strong>


                                                                        <table className="table table-hover border-secondary table-bordered table-info border" style={{ width: '100%', marginTop: '10px', fontSize: '15px' }}>
                                                                            <thead>
                                                                                <tr className='align-top border-secondary'>
                                                                                    <th>#</th>
                                                                                    <th>DOS</th>
                                                                                    <th>DOT</th>
                                                                                    <th>Claim ID</th>
                                                                                    <th>CPT</th>
                                                                                    <th>Transaction Code</th>
                                                                                    <th>Transaction</th>
                                                                                    <th>Total Amt</th>
                                                                                    <th>Insurance Amt</th>
                                                                                    <th>Patient Amt</th>
                                                                                    <th>DOP</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>


                                                                                {Array.isArray(transactionData[index]) && transactionData[index].length > 0 ? (

                                                                                    transactionData[index]?.map((item, txnIndex) => (
                                                                                        <tr key={txnIndex}>
                                                                                            <td>{txnIndex + 1}</td>
                                                                                            <td>{formatDOSDate(item.DOS)}</td>
                                                                                            <td>{formatDOSDate(item.TransactionAddedDate)}</td>
                                                                                            <td>{item.ClaimID}</td>
                                                                                            <td>{item.CPT}</td>
                                                                                            <td>{item.TransactionCode}</td>
                                                                                            <td>{item.TransactionCodeDescription}</td>
                                                                                            <td>{item.TransactionAmt}</td>
                                                                                            <td>{item.InsuranceAmt}</td>
                                                                                            <td>{item.PatientAmt}</td>
                                                                                            <td>{formatDOSDate(item.PostingDate)}</td>

                                                                                        </tr>

                                                                                    ))



                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={11}>No Records Found</td>
                                                                                    </tr>
                                                                                )}

                                                                                <tr className='table-secondary'>
                                                                                    <td colSpan={11}>
                                                                                        {(() => {
                                                                                            const patTotal = transactionData[index].reduce(
                                                                                                (sum, item) => sum + (parseFloat(item.PatientAmt) || 0),
                                                                                                0
                                                                                            );
                                                                                            const insTotal = transactionData[index].reduce(
                                                                                                (sum, item) => sum + (parseFloat(item.InsuranceAmt) || 0),
                                                                                                0
                                                                                            );
                                                                                            const total = patTotal + insTotal;

                                                                                            return (
                                                                                                <>
                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Pat Balance:</label>
                                                                                                    <label style={{ marginRight: '10px' }}>{patTotal.toFixed(2)}</label>

                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Insurance Balance:</label>
                                                                                                    <label style={{ marginRight: '10px' }}>{insTotal.toFixed(2)}</label>

                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Total Balance:</label>
                                                                                                    <label>{total.toFixed(2)}</label>
                                                                                                </>
                                                                                            );
                                                                                        })()}
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>



                                                                        </table>


                                                                    </div>


                                                                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #ccc' }}>

                                                                        <strong>Audit Log</strong>


                                                                        <table className="table table-hover border-secondary table-bordered table-info border" style={{ width: '100%', marginTop: '10px', fontSize: '15px' }}>
                                                                            <thead>
                                                                                <tr className='align-top border-secondary'>
                                                                                    <th>#</th>
                                                                                    <th>Description</th>
                                                                                    <th>Date</th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>


                                                                                {Array.isArray(auditData[index]) && auditData[index].length > 0 ? (

                                                                                    auditData[index]?.map((item, txnIndex) => (
                                                                                        <tr key={txnIndex}>
                                                                                            <td>{txnIndex + 1}</td>
                                                                                            <td>{item.AuditDescription}</td>
                                                                                            <td>{formatDOSDate(item.AuditDate)}</td>

                                                                                        </tr>
                                                                                    ))

                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={11}>No Records Found</td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>


                                                                    </div>


                                                                </>
                                                            )}




                                                        </td>



                                                        <td className='table-bordered border border-white sticky-col-5' style={{ backgroundColor }}>
                                                            <label className={`linkspan print-label ${item.EligibilityCheckCount > 0 ? 'EligibilityChecked' : 'EligibilityNotChecked'}`} onClick={() => handlePatLinkClick(item)}>
                                                                {item.LastName},{item.FirstName}

                                                            </label>
                                                        </td>

                                                        <td className='table-bordered border border-white'><label>{item.totalcharge}</label></td>

                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.recvdCharge}</label>
                                                        </td>
                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.SecrecvdCharge}</label>
                                                        </td>


                                                        <td className='table-bordered border border-white'>
                                                            {item.Adjustment}
                                                        </td>



                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.SecPendingAmt}</label>
                                                        </td>


                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.dDeductible}</label>
                                                        </td>

                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.PatientAmount}</label>
                                                        </td>


                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.Copay}</label>

                                                        </td>


                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.WriteOffAmount}</label>
                                                        </td>
                                                        <td className='table-bordered border border-white'><label>{item.AdminWriteOff}</label>
                                                            <input type='checkbox' style={{ marginLeft: '5px' }}
                                                                className='input'
                                                                checked={selectedAdminWriteRows.includes(index)}
                                                                onChange={() => handleAdminRowCheckboxChange(index)}
                                                            />
                                                        </td>
                                                        <td className='table-bordered border border-white'><label>{item.claimbln}</label>

                                                        </td>


                                                    </>
                                                )}

                                                {activeView === "notesWorkflow" && (
                                                    <>
                                                        <td className='table-bordered border border-white sticky-col-1' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                                                        <td className='table-bordered border border-white sticky-col-2' style={{ width: '100px' }}><label>{item.LocationNickname}</label></td>
                                                        <td className='table-bordered border border-white sticky-col-3' style={{ backgroundColor, width: '120px' }}>

                                                            {formatDOSDate(item.ClaimDOS)}</td>

                                                        <td className='table-bordered border border-white sticky-col-4'
                                                            style={{
                                                                backgroundColor: item.updatedby && item.UpdatedDateTime ? 'lightpink' : '',
                                                            }}
                                                        >

                                                            <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                                                                {item.ClaimId}
                                                            </span>


                                                            <span style={{ marginLeft: '10px' }} onClick={() => toggleRowExpansion(index, item)}>
                                                                <FontAwesomeIcon
                                                                    icon={expandedRows[index] ? faMinus : faPlus}
                                                                    style={{ cursor: 'pointer', fontSize: '18px', marginTop: '10px' }}
                                                                />
                                                            </span>


                                                            {expandedRows[index] && (

                                                                <>
                                                                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #ccc' }}>

                                                                        <strong>Transactions</strong>


                                                                        <table className="table table-hover border-secondary table-bordered table-info border" style={{ width: '100%', marginTop: '10px', fontSize: '15px' }}>
                                                                            <thead>
                                                                                <tr className='align-top border-secondary'>
                                                                                    <th>#</th>
                                                                                    <th>DOS</th>
                                                                                    <th>DOT</th>
                                                                                    <th>Claim ID</th>
                                                                                    <th>CPT</th>
                                                                                    <th>Transaction Code</th>
                                                                                    <th>Transaction</th>
                                                                                    <th>Total Amt</th>
                                                                                    <th>Insurance Amt</th>
                                                                                    <th>Patient Amt</th>
                                                                                    <th>DOP</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>


                                                                                {Array.isArray(transactionData[index]) && transactionData[index].length > 0 ? (

                                                                                    transactionData[index]?.map((item, txnIndex) => (
                                                                                        <tr key={txnIndex}>
                                                                                            <td>{txnIndex + 1}</td>
                                                                                            <td>{formatDOSDate(item.DOS)}</td>
                                                                                            <td>{formatDOSDate(item.TransactionAddedDate)}</td>
                                                                                            <td>{item.ClaimID}</td>
                                                                                            <td>{item.CPT}</td>
                                                                                            <td>{item.TransactionCode}</td>
                                                                                            <td>{item.TransactionCodeDescription}</td>
                                                                                            <td>{item.TransactionAmt}</td>
                                                                                            <td>{item.InsuranceAmt}</td>
                                                                                            <td>{item.PatientAmt}</td>
                                                                                            <td>{formatDOSDate(item.PostingDate)}</td>

                                                                                        </tr>

                                                                                    ))



                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={11}>No Records Found</td>
                                                                                    </tr>
                                                                                )}

                                                                                <tr className='table-secondary'>
                                                                                    <td colSpan={11}>
                                                                                        {(() => {
                                                                                            const patTotal = transactionData[index].reduce(
                                                                                                (sum, item) => sum + (parseFloat(item.PatientAmt) || 0),
                                                                                                0
                                                                                            );
                                                                                            const insTotal = transactionData[index].reduce(
                                                                                                (sum, item) => sum + (parseFloat(item.InsuranceAmt) || 0),
                                                                                                0
                                                                                            );
                                                                                            const total = patTotal + insTotal;

                                                                                            return (
                                                                                                <>
                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Pat Balance:</label>
                                                                                                    <label style={{ marginRight: '10px' }}>{patTotal.toFixed(2)}</label>

                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Insurance Balance:</label>
                                                                                                    <label style={{ marginRight: '10px' }}>{insTotal.toFixed(2)}</label>

                                                                                                    <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Total Balance:</label>
                                                                                                    <label>{total.toFixed(2)}</label>
                                                                                                </>
                                                                                            );
                                                                                        })()}
                                                                                    </td>
                                                                                </tr>

                                                                            </tbody>



                                                                        </table>


                                                                    </div>


                                                                    <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#f8f9fa', border: '1px solid #ccc' }}>

                                                                        <strong>Audit Log</strong>


                                                                        <table className="table table-hover border-secondary table-bordered table-info border" style={{ width: '100%', marginTop: '10px', fontSize: '15px' }}>
                                                                            <thead>
                                                                                <tr className='align-top border-secondary'>
                                                                                    <th>#</th>
                                                                                    <th>Description</th>
                                                                                    <th>Date</th>

                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>


                                                                                {Array.isArray(auditData[index]) && auditData[index].length > 0 ? (

                                                                                    auditData[index]?.map((item, txnIndex) => (
                                                                                        <tr key={txnIndex}>
                                                                                            <td>{txnIndex + 1}</td>
                                                                                            <td>{item.AuditDescription}</td>
                                                                                            <td>{formatDOSDate(item.AuditDate)}</td>

                                                                                        </tr>
                                                                                    ))

                                                                                ) : (
                                                                                    <tr>
                                                                                        <td colSpan={11}>No Records Found</td>
                                                                                    </tr>
                                                                                )}
                                                                            </tbody>
                                                                        </table>


                                                                    </div>


                                                                </>
                                                            )}

                                                        </td>

                                                        <td className='table-bordered border border-white sticky-col-5' style={{ backgroundColor }}>
                                                            <label className={`linkspan print-label ${item.EligibilityCheckCount > 0 ? 'EligibilityChecked' : 'EligibilityNotChecked'}`} onClick={() => handlePatLinkClick(item)}>
                                                                {item.LastName},{item.FirstName}

                                                            </label>
                                                        </td>


                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.PaymentChqueNo}</label>
                                                        </td>

                                                        <td className='table-bordered border border-white'>
                                                            <label>{formatDOSDate(item.PaymentChequeDate)}</label>

                                                        </td>
                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.PayerRefNumber}</label>
                                                        </td>
                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.SecCPTChequeNumber}</label>
                                                        </td>

                                                        <td className='table-bordered border border-white'>
                                                            <label>{formatDOSDate(item.SecCPTChequeDate)}</label>

                                                        </td>
                                                        <td className='table-bordered border border-white'>
                                                            <label>{item.SecPayerclaimRefNumber}</label>
                                                        </td>
                                                        <td className='table-bordered border border-white'>{item.providername}
                                                            <FontAwesomeIcon className="hide-on-print" style={{ marginLeft: '5px', color: 'red', cursor: 'pointer' }} onClick={() => GetProviderPDF(item)} icon={faFilePdf} />
                                                        </td>

                                                        <td className='table-bordered border border-white'>{item.UpdaterName}</td>
                                                        <td className='table-bordered border border-white'>{item.SubmitterName}</td>


                                                        <td className='table-bordered border border-white'>{item.Remarks}
                                                            <div className='claimremarks'></div>
                                                            <div className='claimremarks'></div>
                                                        </td>

                                                        <td className='table-bordered border border-white'>
                                                            {item.ErrorDetails}
                                                        </td>


                                                        <td className='table-bordered border border-white'>

                                                            <input style={{ marginLeft: '6px' }} type='checkbox'
                                                                key={index}
                                                                checked={selectedResubmitRows.includes(index)}
                                                                disabled={item.recvdCharge > 0 || item.recvdCharge === null}
                                                                onChange={() => handleReSubmitCheckboxChange(index)}
                                                            />
                                                        </td>
                                                        <td className='table-bordered border border-white'>
                                                            <textarea type='text' style={{ backgroundColor: item.ClaimNotes !== null ? 'lightgray' : 'white' }}
                                                                value={item.ClaimNotes}
                                                                onChange={(e) => UpdateClaimNotes(e.target.value, item)}
                                                            />

                                                        </td>

                                                    </>
                                                )}
                                            </tr>

                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: "center" }}>No records found</td>
                                    </tr>
                                )}






                            </tbody>




                            <tr style={{ backgroundColor: 'lightgray' }}>

                                {activeView === "claimInfo" && (
                                    <>
                                        <td className='table-bordered border border-white'></td>
                                        <td className='table-bordered border border-white'>Total </td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white'></td>
                                        <td className='table-bordered border border-white'> </td>
                                        <td className='table-bordered border border-white'> </td>
                                        <td className='table-bordered border border-white'> </td>
                                        <td className='table-bordered border border-white'>{totals.totalUnits}</td>
                                    </>
                                )}

                                {activeView === "payments" && (
                                    <>
                                        <td className='table-bordered border border-white'>Total </td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white rectext'></td>
                                        <td className='table-bordered border border-white'>${totals.totalSubmitted.toFixed(2)}</td>
                                        <td className='table-bordered border border-white'>${totals.totalReceived.toFixed(2)}</td>
                                        <td className='table-bordered border border-white'>${totals.totalSecReceived.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalAdjustmentAmt.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalSecPendingAmt.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalDeductible.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalPatientRes.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalCopay.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalWriteOff.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalAdminWriteOff.toFixed(2)} </td>
                                        <td className='table-bordered border border-white'>${totals.totalBalance.toFixed(2)} </td>

                                    </>
                                )}
                            </tr>




                        </table>



                        {showConfirmSaveModal && (

                            <div className='adminwrite-fax mt-5' ref={modalRef}>
                                <label>Select Transaction Code</label>
                                <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.3rem' }} onClick={handleCloseModals} icon={faXmark} />
                                <br />
                                <select style={{ width: '400px', height: '25px', marginTop: '3px' }}
                                    value={selectedTransactionCode}
                                    onChange={(e) => setSelectedTransactionCode(e.target.value)}
                                >
                                    {transactionCodes.map((item, index) => (

                                        <option value={item.TransactionCodeID}>{item.TransactionCodeDescription}</option>
                                    ))}
                                </select>

                                <br />
                                <button className='btn-style3 mt-2' onClick={handleSaveClaimCPTAdminWriteOffCharges}>Submit</button>

                            </div>
                        )}



                        {showCopaySuccessModal && (
                            <div className="alertmsg-modal">
                                <label style={{ backgroundColor: "#18A6EC" }}></label>
                                <FontAwesomeIcon
                                    style={{
                                        float: "right",
                                        fontWeight: "bolder",
                                        fontSize: "1rem",
                                        backgroundColor: "red",
                                        padding: "5px",
                                        cursor: "pointer",
                                    }}
                                    onClick={handleCloseModals}
                                    icon={faXmark}
                                />
                                <div style={{ backgroundColor: "#18A6EC", color: "white", padding: "10px" }}>
                                    {errorMessage}
                                </div>
                            </div>
                        )}



                        {showVerifiedSaveModal && (

                            <div className='verified-fax'>

                                <textarea placeholder='comments' style={{ width: '300px', height: '80px', borderRadius: '5px' }}
                                    value={selectedVerifiedData}
                                    onChange={(e) => setSelectedVerifiedData(e.target.value)}
                                />
                                <br />
                                <button className='btn-style3 mt-2' onClick={handleCloseModals} >Cancel</button>
                                <button className='btn-style3 mt-2' onClick={handleSaveVerifiedData}>Confirm</button>

                            </div>
                        )}

                    </div>



                    {showServiceErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one Filter from Service...</p>

                        </div>

                    )}


                    {showSelectErrorModal && (

                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>please select atleast one claim...</p>

                        </div>

                    )}




                    {showSuccessModal && (
                        <div className='alert-modal'>
                            <label></label>
                            <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1.1rem', backgroundColor: 'red' }} onClick={handleCloseModals} icon={faXmark} />
                            <p>Selected Claim Successfully Closed</p>

                        </div>
                    )}



                    {showPopup && (
                        <div style={{
                            position: 'fixed',
                            bottom: '50px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            backgroundColor: '#333',
                            color: '#fff',
                            padding: '10px 20px',
                            borderRadius: '5px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                            zIndex: 1000,
                            height: '100px',
                            width: '400px',
                            textAlign: 'center'
                        }}>
                            <label style={{ marginTop: '20px', fontSize: '1.4rem' }}>{popupMessage}</label>
                        </div>
                    )}



                    {showFaxModal && (

                        <Draggable>
                            <div className='dialog-box2'>


                                <table className="table" >

                                    <thead>

                                        <tr>
                                            <td className='topnavsub'>
                                                <FontAwesomeIcon style={{ width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black', float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white' }}
                                                    onClick={handleCloseModals} icon={faXmark} />

                                            </td>

                                        </tr>

                                        <tr >

                                            <td style={{ backgroundColor: '#ECF7FB' }} >   <label >Claim ID:  {selectedClaimID}  </label></td>

                                        </tr>

                                        <tr>

                                            <td>

                                                {eventData.map((item, index) => (
                                                    <>


                                                        <div className='event-style' key={index}>
                                                            <label>{item.DataCurStatus}</label>
                                                            <br />
                                                            <label>{formatDOSDate(item.EventDateTime)}- {item.UserFName}</label>

                                                        </div>

                                                        {index < eventData.length - 1 && (

                                                            <FontAwesomeIcon style={{ fontWeight: 'bolder', fontSize: '1.8rem' }} icon={faArrowRight} />

                                                        )}
                                                    </>
                                                ))}
                                            </td>
                                        </tr>

                                    </thead>

                                    <tbody>



                                    </tbody>


                                </table>


                            </div>
                        </Draggable>


                    )}







                    {showDataModal && (

                        <Draggable>
                            <div className='dialog-box3 p-2' >

                                <div className='d-flex'>
                                    <label style={{ fontFamily: 'sans-serif', fontWeight: '600' }}>Patient Name:
                                        <Link>{selectedPatname}</Link>
                                    </label>

                                    <label style={{ fontFamily: 'sans-serif', fontWeight: '600', marginLeft: '60px' }}>DOB: </label>

                                    <label style={{ fontFamily: 'sans-serif', fontWeight: '500', marginLeft: '5px' }}>{selectedDOB}</label>


                                    <div className='topnavsub2'>
                                        <FontAwesomeIcon style={{ width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black', float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white', marginLeft: '40px' }}
                                            onClick={handleCloseModals} icon={faXmark} />

                                    </div>
                                </div>
                                <table className="table table-bordered border-secondary border-white" >

                                    <thead>

                                        <tr>



                                        </tr>



                                        <tr>

                                            <th className='text-white  border-white' style={{ backgroundColor: '#1a9b8c', width: '30px', }}>#</th>


                                            <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#1a9b8c', }}>Claim ID

                                            </th>


                                            <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#1a9b8c' }} >DOS


                                            </th>

                                            <th className='col col-th-style  text-white  border-white' style={{ backgroundColor: '#1a9b8c', }}>Submit Date

                                            </th>


                                            <th className='col col-th text-white  border-white' style={{ backgroundColor: '#1a9b8c' }}><label style={{ width: '100px' }}>Submit By</label>

                                            </th>


                                        </tr>



                                    </thead>



                                </table>

                            </div>
                        </Draggable>


                    )}











                </div>


            </div>




        </>
    )
}

export default TransactionLogs;